import {
	AdditionTypes,
	AddressType,
	AuditTrailOperations,
	BodyTypes,
	BroadcastMessageType,
	CancelCoverageApplyFundsTo,
	CancelCoverageStatus,
	CBCCreditPullVersions,
	CBCReportTypes,
	CDKDealStatus,
	CDKMappingLocation,
	ComparisonType,
	ComponentApi,
	CreationSource,
	CreditAppButtonsActions,
	CreditAppEmploymentStatus,
	CreditAppResidenceStatus,
	CreditAppTypeEmployee,
	CreditReportBureauErrorCode,
	CreditReportFlagTypes,
	CreditReportReportMessagesCodes,
	CustomerApplicationEmploymentStatus,
	CustomerApplicationEnterpriseType,
	CustomerApplicationHousingStatus,
	CustomerApplicationStatus,
	CustomerDocumentSubtype,
	CustomerDocumentType,
	CustomerIdentificationTypes,
	CustomerRetrievalStatus,
	CustomerTriggers,
	CustomerViews,
	DataFormat,
	DealEmployeeRoleTypes,
	DealGoalTypes,
	DealLoJackStatus,
	DealRoomState,
	DealStatuses,
	DealTypeEnum,
	Department,
	DepartmentRoles,
	DocAssociation,
	DropdownSortMode,
	ExceptionType,
	FIManagerTriggers,
	FraudRiskLevel,
	FuelTypes,
	HttpStatusCode,
	IDVStoreSettings,
	Language,
	LogWhat,
	MeetingParticipant,
	OilType,
	OverlayTypes,
	PanelCustomerSteps,
	PaperworkDocumentTypes,
	PaperworkStatus,
	PartnerCodeType,
	PartnerPaperworkMethod,
	PersonType,
	PlaidCountries,
	PlaidIdTypes,
	PlaidIdvStepStatus,
	PlaidIncomeSource,
	PlaidIncomeType,
	PlaidInteraction,
	PlaidLanguages,
	PlaidPayFrequency,
	PlaidPayrollFlow,
	PlaidPayType,
	PlaidProducts,
	PlaidVerificationStatus,
	PlateTransactionType,
	PricingListOptionPriceSplits,
	PricingPlanSelectors,
	FIProductType,
	ProfitFlags,
	ProfitMethods,
	RatingStatus,
	RedFlagsStatus,
	RedirectType,
	ReportFieldTypes,
	ReportTypes,
	RichTableRangeFilterTypes,
	RTFileType,
	SaturnCreditBureaus,
	Sounds,
	SSNTypes,
	StatusPriorityOrder,
	StatusTypes,
	StatusWeight,
	StoreFileTypes,
	TextMessagingProviders,
	TokenStatus,
	UserAccesses,
	VehicleDeliveryMethods,
	VehicleMileageStatus,
	VehiclePrimaryUsage,
	VehicleSurcharges,
	VideoSourceType,
	VideosSeen,
	WarrantyExpirationDateRules,
	WarrantyExpirationMilesRules,
	DataModel as DataModelEnum,
	DDISubmitDocumentTypes as DDISubmitDocumentTypesEnum,
	DealChecklistType as DealChecklistTypeEnum,
	DocumentGenerationType as DocumentGenerationTypeEnum,
	LegalTermTypes as LegalTermTypesEnum,
	LenderContactType as LenderContactTypeEnum,
	LenderDivisionType as LenderDivisionTypeEnum,
	PaperworkDocumentStatus as PaperworkDocumentStatusEnum,
	PayoffQuoteInquiryTypeInquiryType as PayoffQuoteInquiryTypeInquiryTypeEnum,
	PayoffQuoteInquiryTypeProductType as PayoffQuoteInquiryTypeProductTypeEnum,
	ReasonOfCancellation as ReasonOfCancellationEnum,
	R1CreditDecision as R1CreditDecisionEnum,
	ExternalDMSSource as ExternalDMSSourceEnum,
} from './SharedEnums';
import { DataDefinitionType } from './CDataDefinition';

export const PaperworkDocumentStatus = {
	ErrorGenerating: PaperworkDocumentStatusEnum.ErrorGenerating,
	ReadyToBeSigned: PaperworkDocumentStatusEnum.ReadyToBeSigned,
	SigningInProgress: PaperworkDocumentStatusEnum.SigningInProgress,
	PartiallySigned: PaperworkDocumentStatusEnum.PartiallySigned,
	Signed: PaperworkDocumentStatusEnum.Signed,
	ErrorVoiding: PaperworkDocumentStatusEnum.ErrorVoiding,
	Voided: PaperworkDocumentStatusEnum.Voided,
	ErrorActivating: PaperworkDocumentStatusEnum.ErrorActivating,
};
export const OIL_TYPES = {
	NA: OilType.NA,
	REGULAR: OilType.Regular,
	BLEND: OilType.Blend,
	SYNTHETIC: OilType.Synthetic,
	DIESEL: OilType.Diesel,
};

export const oilTypes = [
	{ value: OIL_TYPES.NA, display: 'N/A' },
	{ value: OIL_TYPES.REGULAR, display: 'Regular' },
	{ value: OIL_TYPES.BLEND, display: 'Blend' },
	{ value: OIL_TYPES.SYNTHETIC, display: 'Synthetic' },
	{ value: OIL_TYPES.DIESEL, display: 'Diesel' },
];

export const STORE_FILE_TYPES = {
	MAIN_LOGO: StoreFileTypes.MainLogo,
	toList: () => [
		{ display: 'MainLogo', value: STORE_FILE_TYPES.MAIN_LOGO },
		//{ display: 'Retrieve Application Disabled', value: 2 }
	],
	getDisplay: VALUE => STORE_FILE_TYPES.toList().find(f => f.value === VALUE)?.display,
};
//SignalR Actions

export const CUSTOMER_TRIGGERS = {
	OPEN_VIDEO: CustomerTriggers.OpenVideo,
	PAYMENT_SHEET: CustomerTriggers.PaymentSheet,
	PAPERWORK: CustomerTriggers.Paperwork,
	PAPERWORK_SCREEN: CustomerTriggers.PaperworkScreen,
	FIMANAGER_CONNECTED: CustomerTriggers.FIManagerConnected,
	INFORMATION: CustomerTriggers.Information,
	UPDATE_FIMENU: CustomerTriggers.UpdateFIMenu,
	LOAD_NEXT_DOCUMENT: CustomerTriggers.LoadNextDocument,
	INVOKE_CLICKED_TO_SIGN: CustomerTriggers.InvokeClickedToSign,
};

export const PAPERWORK_STATUS = {
	ERROR: PaperworkStatus.Error,
	PARTIALLY_ACTIVATED: PaperworkStatus.PartiallyActivated,
	NOT_ACTIVATED: PaperworkStatus.NotActivated,
	ACTIVATED: PaperworkStatus.Activated,
	VOIDED_ERROR: PaperworkStatus.VoidedError,
	VOIDED: PaperworkStatus.Voided,
	NO_PAPERWORK: PaperworkStatus.NoPaperwork,
};

export const PaperworkStatusText = {
	1: 'Partially Activated',
	2: 'Not Activated',
	3: 'Activated',
	4: 'Voided with Errors',
	5: 'Voided',
	6: 'No Paperwork',
};
export const PaperworkSignedStatusText = {
	0: 'Not Signed',
	1: 'Partially Signed',
	2: 'Signed',
};

export const FIMANAGER_TRIGGERS = {
	CUSTOMER_CONNECTED: FIManagerTriggers.CustomerConnected,
	UPDATE_FIMENU: FIManagerTriggers.UpdateFIMenu,
};

export const LANG = {
	ENGLISH: 'English',
	SPANISH: 'Spanish',
};

export const LANGUAGE = {
	ENGLISH: Language.English,
	SPANISH: Language.Spanish,
};

export const LANGUAGE_DISPLAY = [
	{
		display: 'English',
		value: LANGUAGE.ENGLISH,
		languageCode: 'en',
		customerApplicationSetting: 'English',
	},
	{
		display: 'Spanish',
		value: LANGUAGE.SPANISH,
		languageCode: 'es',
		customerApplicationSetting: 'Spanish',
	},
];

export const SOUNDS = {
	TERMS_OF_COVERAGE: Sounds.TermsOfCoverage,
	PAYMENT_START_DATE: Sounds.PaymentStartDate,
	SELECT_PAYMENT: Sounds.SelectPayment,
};

export const OVERLAY_TYPES = {
	TEXTBOX: OverlayTypes.TextBox,
	IMAGE: OverlayTypes.Image,
	SIGNATURE: OverlayTypes.Signature,
	FIELD: OverlayTypes.Field,
	INITIALS: OverlayTypes.Initials,
	NOTARY_STAMP: OverlayTypes.NotaryStamp,
};

export const PERSON_TYPES = {
	CUSTOMER: PersonType.Customer,
	COCUSTOMER: PersonType.CoCustomer,
	FIMANAGER: PersonType.FIManager,
	UNKNOWN: PersonType.Unknown,
	ACCOUNTING: PersonType.Accounting,
};

export const CUSTOMER_CREATION_SOURCE = {
	Unknown: CreationSource.Unknown,
	CreditApplication: CreationSource.CreditApplication,
	CustomersPage: CreationSource.CustomersPage,
	FIMenuDeal: CreationSource.FIMenuDeal,
	CreditPull: CreationSource.CreditPull,
	IdentityVerification: CreationSource.IdentityVerification,
};

export const CUSTOMER_VIEWS = {
	RESET: CustomerViews.Reset,
	VIDEO_PRESENTATION: CustomerViews.VideoPresentation,
	PAYMENTSHEET_PAGE: CustomerViews.PaymentSheetPage,
	PAPERWORK_PAGE: CustomerViews.PaperworkPage,
	PRESENTATION_PAGE: CustomerViews.PresentationPage,
	GRAPH_PAGE: CustomerViews.GraphPage,
	PAYMENTSHEET_PREFERRED_COVERAGE: CustomerViews.PaymentSheetPreferredCoverage,
	PAYMENTSHEET_PAYMENT_START: CustomerViews.PaymentSheetPaymentStart,
	PAYMENTSHEET_CAROUSEL: CustomerViews.PaymentSheetCarousel,
	ALL_VIDEOS: CustomerViews.AllVideos,
	PAYMENTSHEET_PRINTED: CustomerViews.PaymentSheetPrinted,
	FIRST_VIDEO_VIEWED: CustomerViews.FirstVideoViewed,
	VIDEOS_SEEN: CustomerViews.VideosSeen,
	PAYMENTSHEET_PREFERRED_COVERAGE_FINISHED: CustomerViews.PaymentSheetPreferredCoverageFinished,
	PAYMENTSHEET_PAYMENT_START_FINISHED: CustomerViews.PaymentSheetPaymentStartDateFinished,
	PAYMENTSHEET_CAROUSEL_FINISHED: CustomerViews.PaymentSheetCarouselFinished,
	MEETING_ROOM_CREATION: CustomerViews.MeetingRoomCreation,
	CONNECTED: CustomerViews.Connected,
	WAITING: CustomerViews.Waiting,
	DOC_SIGN: CustomerViews.DocSign,
	ALL_SIGN: CustomerViews.AllSign,
	PREFERRED_COVERAGE_TERM_SELECTED: CustomerViews.PreferredCoverageTermSelected,
	DAYS_TO_NEXT_PAYMENT_SELECTED: CustomerViews.DaysToNextPaymentSelected,
	OPENING: CustomerViews.Opening,
	PROCESSING: CustomerViews.Processing,
	INFORMATION: CustomerViews.Information,
};

export const customerViews = {
	[CUSTOMER_VIEWS.RESET]: 'Reset',
	[CUSTOMER_VIEWS.VIDEO_PRESENTATION]: 'Video Presentation',
	[CUSTOMER_VIEWS.PAYMENTSHEET_PAGE]: 'PaymentSheet Page',
	[CUSTOMER_VIEWS.PAPERWORK_PAGE]: 'Paperwork Page',
	[CUSTOMER_VIEWS.PRESENTATION_PAGE]: 'Presentation Page',
	[CUSTOMER_VIEWS.GRAPH_PAGE]: 'Graph Page',
	[CUSTOMER_VIEWS.PAYMENTSHEET_PREFERRED_COVERAGE]: 'PaymentSheet Page: Preferred Coverage',
	[CUSTOMER_VIEWS.PAYMENTSHEET_PAYMENT_START]: 'PaymentSheet Page: Payment Due Date',
	[CUSTOMER_VIEWS.PAYMENTSHEET_CAROUSEL]: 'PaymentSheet Page: Coverage Selection',
	[CUSTOMER_VIEWS.ALL_VIDEOS]: 'All Videos Seen',
	[CUSTOMER_VIEWS.PAYMENTSHEET_PRINTED]: 'PaymentSheet Printed',
	[CUSTOMER_VIEWS.FIRST_VIDEO_VIEWED]: 'First Video Finished',
	[CUSTOMER_VIEWS.VIDEOS_SEEN]: 'Video was Seen',
	[CUSTOMER_VIEWS.PAYMENTSHEET_PREFERRED_COVERAGE_FINISHED]: 'PaymentSheet Page: Preferred Coverage Finished',
	[CUSTOMER_VIEWS.PAYMENTSHEET_PAYMENT_START_FINISHED]: 'PaymentSheet Page: Payment Due Date Finished',
	[CUSTOMER_VIEWS.PAYMENTSHEET_CAROUSEL_FINISHED]: 'PaymentSheet Page: Coverage Selection Finished',
	[CUSTOMER_VIEWS.MEETING_ROOM_CREATION]: 'Meeting Created',
	[CUSTOMER_VIEWS.CONNECTED]: 'Connected',
	[CUSTOMER_VIEWS.WAITING]: 'Waiting',
	[CUSTOMER_VIEWS.DOC_SIGN]: 'DocSign',
	[CUSTOMER_VIEWS.ALL_SIGN]: 'AllSign',
	[CUSTOMER_VIEWS.PREFERRED_COVERAGE_TERM_SELECTED]: 'Preferred Coverage Term Selected',
	[CUSTOMER_VIEWS.DAYS_TO_NEXT_PAYMENT_SELECTED]: 'Days to Next payment Selected',
	[CUSTOMER_VIEWS.OPENING]: 'Opening',
	[CUSTOMER_VIEWS.PROCESSING]: 'Processing',
	[CUSTOMER_VIEWS.INFORMATION]: 'Information',
};

export const VIDEOS_SEEN = {
	NO_COVERAGE_LEFT: VideosSeen.NoCoverageLeft,
	POWER_TRAIN: VideosSeen.PowerTrainOnly,
	BUMPER_TO_BUMPER: VideosSeen.BumperToBumper,
	ROADSIDE_LOANERS: VideosSeen.RoadsideLoaners,
	ROADSIDE_NO_LOANERS: VideosSeen.RoadsideNoLoaners,
	NO_ROADSIDE_LOANERS: VideosSeen.NoRoadsideLoaners,
	NO_ROADSIDE_NO_LOANERS: VideosSeen.NoRoadsideNoLoaners,
	LOANERS: VideosSeen.Loaners,
	NO_LOANERS: VideosSeen.NoLoaners,
	FOURTH: VideosSeen.Fourth,
	FIFTH: VideosSeen.Fifth,
	SIXTH: VideosSeen.Sixth,
	SEVENTH: VideosSeen.Seventh,
	EIGHTH: VideosSeen.Eighth,
	LEASING: VideosSeen.Leasing,
	NINETH: VideosSeen.Ninth,
	GAP: VideosSeen.Gap,
	NO_GAP: VideosSeen.NoGap,
	ELEVENTH: VideosSeen.Eleventh,
	DISCLAIMER: VideosSeen.Disclaimer,
};

export const VIDEOS_SEEN_TITLES = {
	1: 'No Coverage Left',
	2: 'PowerTrain Only',
	3: 'With Bumper to  Bumper Left',
	4: 'With Roadside and Loaners',
	5: 'With Roadside but Without Loaners',
	6: 'Without Roadside but with Loaners',
	7: 'Without Roadside and Without Loaners',
	8: 'With Loaners',
	9: 'Without Loaners',
	10: 'Explanatory Video (No. 4)',
	11: 'Explanatory Video (No. 5)',
	12: 'Explanatory Video (No. 6)',
	13: 'Explanatory Video (No. 7)',
	14: 'Explanatory Video (No. 8)',
	15: ' Leasing Vehicle',
	16: 'Explanatory Video (No. 9)',
	17: 'With GAP                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              ',
	18: 'Without GAP (Lease or Cash)',
	19: 'Explanatory Video (No. 11)',
	20: 'DISCLAIMER',
};

export const API_ERROR_DESCRIPTION = {
	400: {
		status: 'Bad Request',
		message: 'The request was invalid.',
	},
	401: {
		status: 'Unauthorized',
		message: 'The request did not include an authentication token or the authentication token was expired.',
	},
	403: {
		status: 'Forbidden',
		message: 'The client did not have permission to access the requested resource.',
	},
	404: {
		status: 'Not Found',
		message: 'The requested resource was not found.',
	},
	405: {
		status: 'Method Not Allowed',
		message: 'The HTTP method in the request was not supported by the resource.For example, the DELETE method cannot be used with the Agent API.',
	},
	409: {
		status: 'Conflict',
		message:
			'The request could not be completed due to a conflict.For example, POST ContentStore Folder API cannot complete if the given file or folder name already exists in the parent location.',
	},
	500: {
		status: 'Internal Server Error',
		message: 'The request was not completed due to an internal error on the server side.',
	},
	503: {
		status: 'Service Unavailable',
		message: 'The server was unavailable.',
	},
};

export const PARTNER_CODES = {
	USWARRANTY_COMPANY_CODE: PartnerCodeType.USWarrantyCompanyCode,
	USWARRANTY_STORE_CODE: PartnerCodeType.USWarrantyStoreCode,
	NSD_CODE: PartnerCodeType.NSDCode,
	GWC_CODE: PartnerCodeType.GWCCode,
	COMMODORE_CODE: PartnerCodeType.CommodoreCode,
	CALTEX_CODE: PartnerCodeType.CaltexCode,
	PEN_DEALER_ID: PartnerCodeType.PENDealerID,
	PEN_CORNERSTONE: PartnerCodeType.PENCornerstone,
	ROUTEONE_DEALER_ID: PartnerCodeType.RouteOneDealerId,
	ROUTEONE_PARTNER_ID: PartnerCodeType.RouteOnePartnerId,
	MSCAN_ACCOUNT: PartnerCodeType.MScanAccount,
	CAR_FAX_PARTNER_CODE: PartnerCodeType.CarFaxPartnerCode,
	CAR_FAX_UID_CODE: PartnerCodeType.CarFaxUIDCode,
	CBC_CUSTOMERID: PartnerCodeType.CBCCustomerID,
	CBC_MASTER_USERID: PartnerCodeType.CBCMasterID,
	CBC_MASTER_PASSWORD: PartnerCodeType.CBCMasterPassword,
	CBC_USERID: PartnerCodeType.CBCUserID,
	CBC_PASSWORD: PartnerCodeType.CBCPassword,
	DIALPAD_USER_ID: PartnerCodeType.DialpadUserId,
	SPIREON_ACCOUNT_ID: PartnerCodeType.SpireonAccountId,
	DLP_DEALER_ID: PartnerCodeType.DLPDealerId,
	AUTOCOMPLETE_DEALER_ID: PartnerCodeType.AutoCompleteDealerID,
	DDI_PARTNER_ID: PartnerCodeType.DDIPartnerId,
	DDI_DEALER_ID: PartnerCodeType.DDIDealerId,
};

export const CBC_REPORT_TYPES = {
	EFX: CBCReportTypes.EFX,
	XPN: CBCReportTypes.XPN,
	TU: CBCReportTypes.TU,
	XPN_EFX: CBCReportTypes.XPN_EFX,
	TU_EFX: CBCReportTypes.TU_EFX,
	XPN_TU: CBCReportTypes.XPN_TU,
	XPN_TU_EFX: CBCReportTypes.XPN_TU_EFX,
	OFAC: CBCReportTypes.OFAC,
	MLA: CBCReportTypes.MLA,
	reportTypeStringToEnum(inputString) {
		switch (inputString.toUpperCase()) {
			case 'XPN':
				return CBC_REPORT_TYPES.XPN;
			case 'TU':
				return CBC_REPORT_TYPES.TU;
			case 'EFX':
				return CBC_REPORT_TYPES.EFX;
			case 'XPN|TU':
				return CBC_REPORT_TYPES.XPN_TU;
			case 'XPN|EFX':
				return CBC_REPORT_TYPES.XPN_EFX;
			case 'TU|EFX':
				return CBC_REPORT_TYPES.TU_EFX;
			case 'XPN|TU|EFX':
				return CBC_REPORT_TYPES.XPN_TU_EFX;
			case 'OFAC':
				return CBC_REPORT_TYPES.OFAC;
			case 'MLA':
				return CBC_REPORT_TYPES.MLA;
		}
	},
	reportTypeEnumToString(enumNum) {
		switch (enumNum) {
			case CBC_REPORT_TYPES.XPN:
				return 'XPN';
			case CBC_REPORT_TYPES.TU:
				return 'TU';
			case CBC_REPORT_TYPES.EFX:
				return 'EFX';
			case CBC_REPORT_TYPES.XPN_TU:
				return 'XPN|TU';
			case CBC_REPORT_TYPES.XPN_EFX:
				return 'XPN|EFX';
			case CBC_REPORT_TYPES.TU_EFX:
				return 'TU|EFX';
			case CBC_REPORT_TYPES.XPN_TU_EFX:
				return 'XPN|TU|EFX';
			case CBC_REPORT_TYPES.OFAC:
				return 'OFAC';
			case CBC_REPORT_TYPES.MLA:
				return 'MLA';
		}
	},
	reportTypeEnumToName(enumNum) {
		switch (enumNum) {
			case CBC_REPORT_TYPES.XPN:
				return 'Experian';
			case CBC_REPORT_TYPES.TU:
				return 'TransUnion';
			case CBC_REPORT_TYPES.EFX:
				return 'Equifax';
			case CBC_REPORT_TYPES.XPN_TU:
				return 'XPN|TU';
			case CBC_REPORT_TYPES.XPN_EFX:
				return 'XPN|EFX';
			case CBC_REPORT_TYPES.TU_EFX:
				return 'TU|EFX';
			case CBC_REPORT_TYPES.XPN_TU_EFX:
				return 'XPN|TU|EFX';
			case CBC_REPORT_TYPES.OFAC:
				return 'OFAC';
			case CBC_REPORT_TYPES.MLA:
				return 'MLA';
		}
	},
	toList() {
		return [
			{
				text: 'Experian',
				value: CBC_REPORT_TYPES.XPN,
			},
			{
				text: 'TransUnion',
				value: CBC_REPORT_TYPES.TU,
			},
			{
				text: 'Equifax',
				value: CBC_REPORT_TYPES.EFX,
			},
			{
				text: 'XPN|TU',
				value: CBC_REPORT_TYPES.XPN_TU,
			},
			{
				text: 'XPN|EFX',
				value: CBC_REPORT_TYPES.XPN_EFX,
			},
			{
				text: 'TU|EFX',
				value: CBC_REPORT_TYPES.TU_EFX,
			},
			{
				text: 'XPN|TU|EFX',
				value: CBC_REPORT_TYPES.XPN_TU_EFX,
			},
			{
				text: 'OFAC',
				value: CBC_REPORT_TYPES.OFAC,
			},
			{
				text: 'MLA',
				value: CBC_REPORT_TYPES.MLA,
			},
		];
	},
};

export const SATURN_CREDIT_BUREAURS = {
	Equifax: SaturnCreditBureaus.Equifax,
	Experian: SaturnCreditBureaus.Experian,
	TransUnion: SaturnCreditBureaus.TransUnion,
	Ofac: SaturnCreditBureaus.Ofac,
	MLA: SaturnCreditBureaus.MLA,
	toList: () => [
		{ value: SATURN_CREDIT_BUREAURS.Equifax, display: 'Equifax' },
		{ value: SATURN_CREDIT_BUREAURS.Experian, display: 'Experian' },
		{ value: SATURN_CREDIT_BUREAURS.TransUnion, display: 'TransUnion' },
		{ value: SATURN_CREDIT_BUREAURS.Ofac, display: 'OFAC' },
		{ value: SATURN_CREDIT_BUREAURS.MLA, display: 'MLA' },
	],
	getDisplay: value => SATURN_CREDIT_BUREAURS.toList().find(v => v.value === value)?.display,
	getCBC(reportTypes) {
		if (
			reportTypes.includes(SATURN_CREDIT_BUREAURS.Equifax) &&
			reportTypes.includes(SATURN_CREDIT_BUREAURS.Experian) &&
			reportTypes.includes(SATURN_CREDIT_BUREAURS.TransUnion)
		) {
			return ENUMS.CBC_REPORT_TYPES.XPN_TU_EFX;
		} else if (reportTypes.includes(SATURN_CREDIT_BUREAURS.TransUnion) && reportTypes.includes(SATURN_CREDIT_BUREAURS.Equifax)) {
			return ENUMS.CBC_REPORT_TYPES.TU_EFX;
		} else if (reportTypes.includes(SATURN_CREDIT_BUREAURS.TransUnion) && reportTypes.includes(SATURN_CREDIT_BUREAURS.Experian)) {
			return ENUMS.CBC_REPORT_TYPES.XPN_TU;
		} else if (reportTypes.includes(SATURN_CREDIT_BUREAURS.Equifax) && reportTypes.includes(SATURN_CREDIT_BUREAURS.Experian)) {
			return ENUMS.CBC_REPORT_TYPES.XPN_EFX;
		} else if (reportTypes.includes(SATURN_CREDIT_BUREAURS.Experian)) {
			return ENUMS.CBC_REPORT_TYPES.XPN;
		} else if (reportTypes.includes(SATURN_CREDIT_BUREAURS.TransUnion)) {
			return ENUMS.CBC_REPORT_TYPES.TU;
		} else if (reportTypes.includes(SATURN_CREDIT_BUREAURS.Equifax)) {
			return ENUMS.CBC_REPORT_TYPES.EFX;
		} else {
			return null;
		}
	},
};

export const CUSTOMER_REDFLAGSTATUS = {
	Blank: RedFlagsStatus.Blank, // If never credit run.
	NoRedFlags: RedFlagsStatus.NoRedFlags, // Flags came in all good.
	PendingRedflags: RedFlagsStatus.PendingRedflags, // Has Redflags
	ClearedRedflags: RedFlagsStatus.ClearedRedflags,
};

export const CBC_CREDIT_PULL_VERSIONS_FICO = {
	SCORE_8_EFX_F: CBCCreditPullVersions.SCORE_8_EFX_F,
	SCORE_5_EFX_F: CBCCreditPullVersions.SCORE_5_EFX_F,
	AUTO_8_EFX_F: CBCCreditPullVersions.AUTO_8_EFX_F,
	AUTO_9_EFX_F: CBCCreditPullVersions.AUTO_9_EFX_F,
	AUTO_8_EFX_N: CBCCreditPullVersions.AUTO_8_EFX_N,
	SCORE_8_EFX_N: CBCCreditPullVersions.SCORE_8_EFX_N,
	AUTO_5_EFX_N: CBCCreditPullVersions.AUTO_5_EFX_N,
	SCORE_5_EFX_N: CBCCreditPullVersions.SCORE_5_EFX_N,
	AUTO_5_EFX_F: CBCCreditPullVersions.AUTO_5_EFX_F,
	SCORE_9_EFX_N: CBCCreditPullVersions.SCORE_9_EFX_N,
	SCORE_9_EFX_F: CBCCreditPullVersions.SCORE_9_EFX_F,
	AUTO_9_EFX_N: CBCCreditPullVersions.AUTO_9_EFX_N,
	AUTO_SCORE_V9_XPN: CBCCreditPullVersions.AUTO_SCORE_V9_XPN,
	AUTO_V3_XPN: CBCCreditPullVersions.AUTO_V3_XPN,
	ADVANCED_XPN: CBCCreditPullVersions.ADVANCED_XPN,
	ADVANCED_V2_XPN: CBCCreditPullVersions.ADVANCED_V2_XPN,
	BANKCARD_V8_XPN: CBCCreditPullVersions.BANKCARD_V8_XPN,
	CLASSIC_V9_RISK_SCORE_XPN: CBCCreditPullVersions.CLASSIC_V9_RISK_SCORE_XPN,
	RISK_V3_XPN: CBCCreditPullVersions.RISK_V3_XPN,
	RISK_V2_XPN: CBCCreditPullVersions.RISK_V2_XPN,
	AUTO_V2_XPN: CBCCreditPullVersions.AUTO_V2_XPN,
	AUTO_V8_XPN: CBCCreditPullVersions.AUTO_V8_XPN,
	RISK_V8_XPN: CBCCreditPullVersions.RISK_V8_XPN,
	AUTO_SCORE_9_TU: CBCCreditPullVersions.AUTO_SCORE_9_TU,
	AUTO_SCORE_98_TU: CBCCreditPullVersions.AUTO_SCORE_98_TU,
	AUTO_SCORE_4_TU: CBCCreditPullVersions.AUTO_SCORE_4_TU,
	SCORE_9_TU: CBCCreditPullVersions.SCORE_9_TU,
	SCORE_4_TU: CBCCreditPullVersions.SCORE_4_TU,
	AUTO_SCORE_8_TU: CBCCreditPullVersions.AUTO_SCORE_8_TU,
	SCORE_8_TU: CBCCreditPullVersions.SCORE_8_TU,
	SCORE_98_TU: CBCCreditPullVersions.SCORE_98_TU,
	AUTO_SCORE_9_XT_TU: CBCCreditPullVersions.AUTO_SCORE_9_XT_TU,
	//FIXME: CBC Credit Report ENUM refactor - Maria
	// reportTypeStringToEnum(inputString) {
	//     // Convert the input string to a format that matches the enum keys (e.g., remove spaces and convert to uppercase)
	//     const formattedString = inputString.replace(/ /g, '_');

	//     // Check if the formatted string exists in the reverse mapping object
	//     if (formattedString in CBC_CREDIT_PULL_VERSIONS) {
	//         return CBC_CREDIT_PULL_VERSIONS[formattedString];
	//     } else {
	//         // Handle the case when the inputString doesn't match any known report type
	//         return -1; // returning -1 or another default value to indicate an unknown/none report type
	//     }
	// },
	toList: () => [
		{
			text: '-- EFX Auto versions --',
			value: -1,
		},
		{
			text: 'FICO Auto 5 EFX N',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_5_EFX_N,
		},
		{
			text: 'FICO Auto 5 EFX F',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_5_EFX_F,
		},
		{
			text: 'FICO Auto 8 EFX F',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_8_EFX_F,
		},
		{
			text: 'FICO Auto 8 EFX N',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_8_EFX_N,
		},
		{
			text: 'FICO Auto 9 EFX F',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_9_EFX_F,
		},
		{
			text: 'FICO Auto 9 EFX N',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_9_EFX_N,
		},
		{
			text: '-- EFX Regular versions --',
			value: -1,
		},
		{
			text: 'FICO Score 5 EFX N',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_5_EFX_N,
		},
		{
			text: 'FICO Score 5 EFX F',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_5_EFX_F,
		},
		{
			text: 'FICO Score 8 EFX F',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_8_EFX_F,
		},
		{
			text: 'FICO Score 8 EFX N',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_8_EFX_N,
		},
		{
			text: 'FICO Score 9 EFX N',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_9_EFX_N,
		},
		{
			text: 'FICO Score 9 EFX F',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_9_EFX_F,
		},
		{
			text: '-- XPN Auto versions --',
			value: -1,
		},
		{
			text: 'FICO Auto V2 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_V2_XPN,
		},
		{
			text: 'FICO Auto V3 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_V3_XPN,
		},
		{
			text: 'FICO Auto V8 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_V8_XPN,
		},
		{
			text: 'FICO Auto Score V9 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_SCORE_V9_XPN,
		},
		{
			text: '-- XPN Regular versions --',
			value: -1,
		},
		/// maria TODO: currently returning "blocked" for the model code. will f/u w/CBC
		// {
		//     text: "FICO Advanced XPN",
		//
		// },
		{
			text: 'FICO Advanced V2 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.ADVANCED_V2_XPN,
		},
		{
			text: 'FICO Risk V2 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.RISK_V2_XPN,
		},
		{
			text: 'FICO RISK V3 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.RISK_V3_XPN,
		},
		{
			text: 'FICO Risk V8 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.RISK_V8_XPN,
		},
		{
			text: 'FICO Bankcard V8 XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.BANKCARD_V8_XPN,
		},
		{
			text: 'FICO Classic V9 Risk Score XPN',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.CLASSIC_V9_RISK_SCORE_XPN,
		},
		{
			text: '-- TU Auto versions --',
			value: -1,
		},
		{
			text: 'FICO Auto Score 4 TU',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_SCORE_4_TU,
		},
		{
			text: 'FICO Auto Score 8 TU',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_SCORE_8_TU,
		},
		{
			text: 'FICO Auto Score 9 TU',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.AUTO_SCORE_9_TU,
		},
		{
			text: '-- TU Regular versions --',
			value: -1,
		},
		{
			text: 'FICO Score 4 TU',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_4_TU,
		},
		{
			text: 'FICO Score 8 TU',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_8_TU,
		},
		{
			text: 'FICO Score 9 TU',
			value: CBC_CREDIT_PULL_VERSIONS_FICO.SCORE_9_TU,
		},
	],
};

export const CREDITREPORT_REPORT_MESSAGES_CODES = {
	Unknown: CreditReportReportMessagesCodes.Unknown,
	MLACoveredBorrower: CreditReportReportMessagesCodes.MLACoveredBorrower,
	NonMLACoveredBorrower: CreditReportReportMessagesCodes.NonMLACoveredBorrower,
	MLATempUnavailable: CreditReportReportMessagesCodes.MLATempUnavailable,
	MLANotAllowed: CreditReportReportMessagesCodes.MLANotAllowed,
	MLANotPerformed: CreditReportReportMessagesCodes.MLANotPerformed,
};

export const CREDITREPORT_BUREAU_ERROR_CODE = {
	Unknown: CreditReportBureauErrorCode.Unknown,
	OfacNA: CreditReportBureauErrorCode.OfacNA,
	BureauFrozen: CreditReportBureauErrorCode.BureauFrozen,
	ConsumerMinor: CreditReportBureauErrorCode.ConsumerMinor,
	SSNRequired: CreditReportBureauErrorCode.SSNRequired,
};

export const CREDITREPORT_FLAG_TYPES = {
	OFAC: CreditReportFlagTypes.OFAC,
	ADDRESS: CreditReportFlagTypes.Address,
	SSN: CreditReportFlagTypes.SSN,
	FRAUD: CreditReportFlagTypes.Fraud,
	DOB: CreditReportFlagTypes.DOB,
	MLA: CreditReportFlagTypes.MLA,
};

export const SSN_TYPES = {
	SSN: SSNTypes.SSN,
	ITIN: SSNTypes.ITIN,
};

export const CUSTOMER_APPLICATION_STATUS = {
	Created: CustomerApplicationStatus.Created,
	PartiallyCompleted: CustomerApplicationStatus.PartiallyCompleted,
	CompletedNoCredit: CustomerApplicationStatus.CompletedNoCredit,
	Completed: CustomerApplicationStatus.Completed,
};

export const PARTNER_CODES_TYPES = [
	{
		type: PARTNER_CODES.USWARRANTY_COMPANY_CODE,
		name: 'US Warranty Company Code',
	},
	{ type: PARTNER_CODES.USWARRANTY_STORE_CODE, name: 'US Warranty Store Code' },
	{ type: PARTNER_CODES.NSD_CODE, name: 'NSD Code' },
	{ type: PARTNER_CODES.GWC_CODE, name: 'GWC Code' },
	{ type: PARTNER_CODES.COMMODORE_CODE, name: 'Commodore Code' },
	{ type: PARTNER_CODES.CALTEX_CODE, name: 'Caltex Code' },
	{ type: PARTNER_CODES.PEN_DEALER_ID, name: 'PEN Dealer ID' },
	{ type: PARTNER_CODES.PEN_CORNERSTONE, name: 'PEN Cornerstone ID' },
	{ type: PARTNER_CODES.ROUTEONE_DEALER_ID, name: 'RouteOne Dealer ID' },
	{ type: PARTNER_CODES.ROUTEONE_PARTNER_ID, name: 'RouteOne Partner ID' },
	{ type: PARTNER_CODES.MSCAN_ACCOUNT, name: 'MDesk Account' },
	{ type: PARTNER_CODES.CAR_FAX_PARTNER_CODE, name: 'Car Fax Partner Code' },
	{ type: PARTNER_CODES.CAR_FAX_UID_CODE, name: 'Car Fax UID Code' },
	{ type: PARTNER_CODES.CBC_CUSTOMERID, name: 'CBC Customer ID' },
	{ type: PARTNER_CODES.CBC_MASTER_USERID, name: 'CBC Master User ID' },
	{ type: PARTNER_CODES.CBC_MASTER_PASSWORD, name: 'CBC Master Password' },
	{ type: PARTNER_CODES.CBC_USERID, name: 'CBC User ID' },
	{ type: PARTNER_CODES.CBC_PASSWORD, name: 'CBC Password' },
	{ type: PARTNER_CODES.DIALPAD_USER_ID, name: 'Dialpad User ID' },
	{ type: PARTNER_CODES.SPIREON_ACCOUNT_ID, name: 'Spireon Account ID' },
	{ type: PARTNER_CODES.DLP_DEALER_ID, name: 'DLP Dealer ID' },
	{
		type: PARTNER_CODES.AUTOCOMPLETE_DEALER_ID,
		name: 'AutoComplete Dealer ID',
	},
	{ type: PARTNER_CODES.DDI_DEALER_ID, name: 'DDI Dealer ID' },
	{ type: PARTNER_CODES.DDI_PARTNER_ID, name: 'DDI Partner ID' },
];

export const PRODUCT_TYPES = {
	SERVICE_CONTRACT: FIProductType.ServiceContract,
	MAINTENANCE: FIProductType.Maintenance,
	TITANIUM_BUNDLE: FIProductType.TitaniumBundle,
	APPEARANCE: FIProductType.Appearance,
	EXCESS_WEAR_AND_TEAR: FIProductType.ExcessWearAndTear,
	TOWBUSTER: FIProductType.Towbuster,
	ETCH: FIProductType.Etch,
	LOJACK_GPS: FIProductType.Skylink,
	GAP: FIProductType.Gap,
	TIRE_AND_WHEEL: FIProductType.TireAndWheel,
	DING_AND_DENT: FIProductType.DingAndDent,
	KEY_AND_REMOTE: FIProductType.KeyAndRemote,
	CATALYTIC_CONVERTER: FIProductType.CatalyticConverter,
	TOTAL_LOSS_PROTECTION: FIProductType.TotalLossProtection,
	OTHER: FIProductType.Other,
	getDefaultTitleId(PRODUCT_TYPE) {
		switch (PRODUCT_TYPE) {
			case PRODUCT_TYPES.SERVICE_CONTRACT:
				return '10018';
			case PRODUCT_TYPES.MAINTENANCE:
				return '10010';
			case PRODUCT_TYPES.TITANIUM_BUNDLE:
				return '10018';
			case PRODUCT_TYPES.APPEARANCE:
				return '10006';
			case PRODUCT_TYPES.EXCESS_WEAR_AND_TEAR:
				return '10010';
			case PRODUCT_TYPES.TOWBUSTER:
				return 'SATURN0001';
			case PRODUCT_TYPES.ETCH:
				return '10009';
			case PRODUCT_TYPES.LOJACK_GPS:
				return '10009';
			case PRODUCT_TYPES.GAP:
				return '10005';
			case PRODUCT_TYPES.TIRE_AND_WHEEL:
				return '10018';
			case PRODUCT_TYPES.DING_AND_DENT:
				return '10018';
			case PRODUCT_TYPES.KEY_AND_REMOTE:
				return '10018';
			case PRODUCT_TYPES.CATALYTIC_CONVERTER:
				return '10009';
			case PRODUCT_TYPES.TOTAL_LOSS_PROTECTION:
				return '10006';
			case PRODUCT_TYPES.OTHER:
				return '10001';
			default:
				return null;
		}
	},
};

export const productTypes = [
	{
		code: PRODUCT_TYPES.SERVICE_CONTRACT,
		description: 'Extended Service Contract',
		hidden: false,
		fimenuDesc: 'service',
	},
	{
		code: PRODUCT_TYPES.MAINTENANCE,
		description: 'Pre-Paid Maintenance',
		hidden: false,
		fimenuDesc: 'maintenance',
	},
	{
		code: PRODUCT_TYPES.TITANIUM_BUNDLE,
		description: 'Bundle Coverage',
		hidden: false,
		fimenuDesc: 'titanium',
	},
	{
		code: PRODUCT_TYPES.APPEARANCE,
		description: 'Paint & Interior Protection',
		hidden: false,
		fimenuDesc: 'paint',
	},
	{
		code: PRODUCT_TYPES.EXCESS_WEAR_AND_TEAR,
		description: 'Excess Wear & Tear',
		hidden: false,
		fimenuDesc: 'wear',
	},
	{
		code: PRODUCT_TYPES.TOWBUSTER,
		description: 'Towbuster Motor Club',
		hidden: false,
		fimenuDesc: 'towbuster',
	},
	{
		code: PRODUCT_TYPES.ETCH,
		description: 'Traceable Theft Protection',
		hidden: false,
		fimenuDesc: 'theft',
	},
	{
		code: PRODUCT_TYPES.LOJACK_GPS,
		description: 'GPS Tracking Device',
		hidden: false,
		fimenuDesc: 'skylink',
	},
	{
		code: PRODUCT_TYPES.GAP,
		description: 'Guaranteed Asset Protection',
		hidden: false,
		fimenuDesc: 'gap',
	},
	{
		code: PRODUCT_TYPES.DING_AND_DENT,
		description: 'Ding And Dent',
		hidden: true,
		fimenuDesc: null,
	},
	{
		code: PRODUCT_TYPES.TIRE_AND_WHEEL,
		description: 'Tire And Wheel',
		hidden: true,
		fimenuDesc: null,
	},
	{
		code: PRODUCT_TYPES.KEY_AND_REMOTE,
		description: 'Key And Remote',
		hidden: true,
		fimenuDesc: null,
	},
	{
		code: PRODUCT_TYPES.CATALYTIC_CONVERTER,
		description: 'Catalytic Converter',
		hidden: true,
		fimenuDesc: null,
	},
	{
		code: PRODUCT_TYPES.TOTAL_LOSS_PROTECTION,
		description: 'Total Loss Protection',
		hidden: true,
		fimenuDesc: null,
	},
	{
		code: PRODUCT_TYPES.OTHER,
		description: 'Other',
		hidden: true,
		fimenuDesc: null,
	},
];

export const PAPERWORK_DOCUMENT_TYPES = {
	PaperworkDocument: PaperworkDocumentTypes.PaperworkDocument,
	Test: PaperworkDocumentTypes.Test,
	KahuServiceAgreement: PaperworkDocumentTypes.KahuServiceAgreement,
	AcceptDecline: PaperworkDocumentTypes.AcceptDecline,

	USWarrantyVsc: PaperworkDocumentTypes.USWarrantyVsc,
	USWarrantyMaintenance: PaperworkDocumentTypes.USWarrantyMaintenance,
	USWarrantyEtch: PaperworkDocumentTypes.USWarrantyEtch,
	USWarrantyTitanium: PaperworkDocumentTypes.USWarrantyTitanium,
	USWarrantyVscWithMaintenance: PaperworkDocumentTypes.USWarrantyVscWithMaintenance,
	USWarrantyTitaniumDingAndDent: PaperworkDocumentTypes.USWarrantyTitaniumDingAndDent,
	USWarrantyTitaniumTireAndWheel: PaperworkDocumentTypes.USWarrantyTitaniumTireAndWheel,
	USWarrantyTitaniumKeyAndRemote: PaperworkDocumentTypes.USWarrantyTitaniumKeyAndRemote,

	CommodorePaint: PaperworkDocumentTypes.CommodorePaint,

	CalTexPaint: PaperworkDocumentTypes.CalTexPaint,

	GWCService: PaperworkDocumentTypes.GWCService,

	PENService: PaperworkDocumentTypes.PENService,
	PENMaintenance: PaperworkDocumentTypes.PENMaintenance,
	PENTitanium: PaperworkDocumentTypes.PENTitanium,
	PENAppearance: PaperworkDocumentTypes.PENAppearance,
	PENWear: PaperworkDocumentTypes.PENWear,
	PENTowbuster: PaperworkDocumentTypes.PENTowbuster,
	PENEtch: PaperworkDocumentTypes.PENEtch,
	PENLoJack: PaperworkDocumentTypes.PENLoJack,
	PENGap: PaperworkDocumentTypes.PENGap,
	PENDingAndDent: PaperworkDocumentTypes.PENDingAndDent,
	PENTireAndWheel: PaperworkDocumentTypes.PENTireAndWheel,
	PENKeyAndRemote: PaperworkDocumentTypes.PENKeyAndRemote,

	DLPTowbuster: PaperworkDocumentTypes.DLPTowbuster,
	DLPEtch: PaperworkDocumentTypes.DLPEtch,
	DLPGap: PaperworkDocumentTypes.DLPGap,
	DLPCatalyticConverter: PaperworkDocumentTypes.DLPCatalyticConverter,
	DLPTotalLossProtection: PaperworkDocumentTypes.DLPTotalLossProtection,
	DLPWear: PaperworkDocumentTypes.DLPWear,
	DLPService: PaperworkDocumentTypes.DLPService,

	NSDPaint: PaperworkDocumentTypes.NSDPaint,
	NSDTitanium: PaperworkDocumentTypes.NSDTitanium,
	NSDTheft: PaperworkDocumentTypes.NSDTheft,
	NSDTowbuster: PaperworkDocumentTypes.NSDTowbuster,
	NSDWear: PaperworkDocumentTypes.NSDWear,
	NSDGap: PaperworkDocumentTypes.NSDGap,

	CarFax: PaperworkDocumentTypes.CarFax,

	Trades: PaperworkDocumentTypes.Trades,

	Other: PaperworkDocumentTypes.Other,
	RouteOne: PaperworkDocumentTypes.RouteOne,
};

export const paperworkDocumentTypes = [
	{
		value: PAPERWORK_DOCUMENT_TYPES.AcceptDecline,
		typeString: 'AcceptDecline',
		productType: null,
		provider: null,
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.CarFax,
		typeString: 'CarFax',
		productType: null,
		provider: null,
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.RouteOne,
		typeString: 'R1',
		productType: null,
		provider: 'RouteOne',
		isDocumentRequired: false,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.Trades,
		typeString: 'Trades',
		productType: null,
		provider: null,
		isDocumentRequired: true,
	},

	{
		value: PAPERWORK_DOCUMENT_TYPES.KahuServiceAgreement,
		typeString: 'KahuServiceAgreement',
		productType: PRODUCT_TYPES.LOJACK_GPS,
		provider: 'Spireon',
		isDocumentRequired: true,
	},

	{
		value: PAPERWORK_DOCUMENT_TYPES.USWarrantyVsc,
		typeString: 'USWarrantyVsc',
		productType: PRODUCT_TYPES.SERVICE_CONTRACT,
		provider: 'US Warranty',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.USWarrantyMaintenance,
		typeString: 'USWarrantyMaintenance',
		productType: PRODUCT_TYPES.MAINTENANCE,
		provider: 'US Warranty',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.USWarrantyVscWithMaintenance,
		typeString: 'USWarrantyVscWithMaintenance',
		productType: null,
		provider: 'US Warranty',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.USWarrantyEtch,
		typeString: 'USWarrantyEtch',
		productType: PRODUCT_TYPES.ETCH,
		provider: 'US Warranty',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.USWarrantyTitanium,
		typeString: 'USWarrantyTitanium',
		productType: PRODUCT_TYPES.TITANIUM_BUNDLE,
		provider: 'US Warranty',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.USWarrantyTitaniumDingAndDent,
		typeString: 'USWarrantyTitaniumDingAndDent',
		productType: PRODUCT_TYPES.DING_AND_DENT,
		provider: 'US Warranty',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.USWarrantyTitaniumTireAndWheel,
		typeString: 'USWarrantyTitaniumTireAndWheel',
		productType: PRODUCT_TYPES.TIRE_AND_WHEEL,
		provider: 'US Warranty',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.USWarrantyTitaniumKeyAndRemote,
		typeString: 'USWarrantyTitaniumKeyAndRemote',
		productType: PRODUCT_TYPES.KEY_AND_REMOTE,
		provider: 'US Warranty',
		isDocumentRequired: true,
	},

	{
		value: PAPERWORK_DOCUMENT_TYPES.NSDPaint,
		typeString: 'NSDPaint',
		productType: PRODUCT_TYPES.APPEARANCE,
		provider: 'NSD',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.NSDTitanium,
		typeString: 'NSDTitanium',
		productType: PRODUCT_TYPES.TITANIUM_BUNDLE,
		provider: 'NSD',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.NSDTheft,
		typeString: 'NSDTheft',
		productType: PRODUCT_TYPES.ETCH,
		provider: 'NSD',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.NSDTowbuster,
		typeString: 'NSDTowbuster',
		productType: PRODUCT_TYPES.TOWBUSTER,
		provider: 'NSD',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.NSDWear,
		typeString: 'NSDWear',
		productType: PRODUCT_TYPES.EXCESS_WEAR_AND_TEAR,
		provider: 'NSD',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.NSDGap,
		typeString: 'NSDGap',
		productType: PRODUCT_TYPES.GAP,
		provider: 'NSD',
		isDocumentRequired: true,
	},

	{
		value: PAPERWORK_DOCUMENT_TYPES.CommodorePaint,
		typeString: 'CommodorePaint',
		productType: PRODUCT_TYPES.APPEARANCE,
		provider: 'Commodore',
		isDocumentRequired: true,
	},

	{
		value: PAPERWORK_DOCUMENT_TYPES.CalTexPaint,
		typeString: 'CalTexPaint',
		productType: PRODUCT_TYPES.APPEARANCE,
		provider: 'CalTex',
		isDocumentRequired: true,
	},

	{
		value: PAPERWORK_DOCUMENT_TYPES.GWCService,
		typeString: 'GWCService',
		productType: PRODUCT_TYPES.SERVICE_CONTRACT,
		provider: 'GWC',
		isDocumentRequired: true,
	},

	{
		value: PAPERWORK_DOCUMENT_TYPES.PENService,
		typeString: 'PENService',
		productType: PRODUCT_TYPES.SERVICE_CONTRACT,
		provider: 'service',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENMaintenance,
		typeString: 'PENMaintenance',
		productType: PRODUCT_TYPES.MAINTENANCE,
		provider: 'maintenance',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENTitanium,
		typeString: 'PENTitanium',
		productType: PRODUCT_TYPES.TITANIUM_BUNDLE,
		provider: 'titanium',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENDingAndDent,
		typeString: 'PENDingAndDent',
		productType: PRODUCT_TYPES.DING_AND_DENT,
		provider: 'dingAndDent',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENTireAndWheel,
		typeString: 'PENTireAndWheel',
		productType: PRODUCT_TYPES.TIRE_AND_WHEEL,
		provider: 'tireAndWheel',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENKeyAndRemote,
		typeString: 'PENKeyAndRemote',
		productType: PRODUCT_TYPES.KEY_AND_REMOTE,
		provider: 'keyAndRemote',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENAppearance,
		typeString: 'PENAppearance',
		productType: PRODUCT_TYPES.APPEARANCE,
		provider: 'appearance',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENWear,
		typeString: 'PENWear',
		productType: PRODUCT_TYPES.EXCESS_WEAR_AND_TEAR,
		provider: 'wear',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENTowbuster,
		typeString: 'PENTowbuster',
		productType: PRODUCT_TYPES.TOWBUSTER,
		provider: 'towbuster',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENEtch,
		typeString: 'PENEtch',
		productType: PRODUCT_TYPES.ETCH,
		provider: 'etch',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENLoJack,
		typeString: 'PENLoJack',
		productType: PRODUCT_TYPES.LOJACK_GPS,
		provider: 'loJack',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.PENGap,
		typeString: 'PENGap',
		productType: PRODUCT_TYPES.GAP,
		provider: 'gap',
		isDocumentRequired: true,
	},

	{
		value: PAPERWORK_DOCUMENT_TYPES.DLPTowbuster,
		typeString: 'DLPTowbuster',
		productType: PRODUCT_TYPES.TOWBUSTER,
		provider: 'DLP',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.DLPEtch,
		typeString: 'DLPEtch',
		productType: PRODUCT_TYPES.ETCH,
		provider: 'DLP',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.DLPGap,
		typeString: 'DLPGap',
		productType: PRODUCT_TYPES.GAP,
		provider: 'DLP',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.DLPCatalyticConverter,
		typeString: 'DLPCatalyticConverter',
		productType: PRODUCT_TYPES.CATALYTIC_CONVERTER,
		provider: 'DLP',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.DLPTotalLossProtection,
		typeString: 'DLPTotalLossProtection',
		productType: PRODUCT_TYPES.TOTAL_LOSS_PROTECTION,
		provider: 'DLP',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.DLPWear,
		typeString: 'DLPWear',
		productType: PRODUCT_TYPES.EXCESS_WEAR_AND_TEAR,
		provider: 'DLP',
		isDocumentRequired: true,
	},
	{
		value: PAPERWORK_DOCUMENT_TYPES.DLPService,
		typeString: 'DLPService',
		productType: PRODUCT_TYPES.SERVICE_CONTRACT,
		provider: 'DLP',
		isDocumentRequired: true,
	},
];

export const docTypesThatWeActivate = [
	PAPERWORK_DOCUMENT_TYPES.USWarrantyVsc,
	PAPERWORK_DOCUMENT_TYPES.USWarrantyMaintenance,
	PAPERWORK_DOCUMENT_TYPES.USWarrantyEtch,
	PAPERWORK_DOCUMENT_TYPES.USWarrantyTitanium,
	PAPERWORK_DOCUMENT_TYPES.USWarrantyTitaniumDingAndDent,
	PAPERWORK_DOCUMENT_TYPES.USWarrantyTitaniumTireAndWheel,
	PAPERWORK_DOCUMENT_TYPES.USWarrantyTitaniumKeyAndRemote,
	PAPERWORK_DOCUMENT_TYPES.USWarrantyVscWithMaintenance,
	PAPERWORK_DOCUMENT_TYPES.NSDPaint,
	PAPERWORK_DOCUMENT_TYPES.NSDTitanium,
	PAPERWORK_DOCUMENT_TYPES.NSDTheft,
	PAPERWORK_DOCUMENT_TYPES.NSDTowbuster,
	PAPERWORK_DOCUMENT_TYPES.NSDWear,
	PAPERWORK_DOCUMENT_TYPES.NSDGap,
	PAPERWORK_DOCUMENT_TYPES.GWCService,
	PAPERWORK_DOCUMENT_TYPES.PENService,
	PAPERWORK_DOCUMENT_TYPES.PENMaintenance,
	PAPERWORK_DOCUMENT_TYPES.PENTitanium,
	PAPERWORK_DOCUMENT_TYPES.PENDingAndDent,
	PAPERWORK_DOCUMENT_TYPES.PENTireAndWheel,
	PAPERWORK_DOCUMENT_TYPES.PENKeyAndRemote,
	PAPERWORK_DOCUMENT_TYPES.PENAppearance,
	PAPERWORK_DOCUMENT_TYPES.PENWear,
	PAPERWORK_DOCUMENT_TYPES.PENTowbuster,
	PAPERWORK_DOCUMENT_TYPES.PENEtch,
	PAPERWORK_DOCUMENT_TYPES.PENLoJack,
	PAPERWORK_DOCUMENT_TYPES.PENGap,
	PAPERWORK_DOCUMENT_TYPES.DLPTowbuster,
	PAPERWORK_DOCUMENT_TYPES.DLPEtch,
	PAPERWORK_DOCUMENT_TYPES.DLPGap,
	PAPERWORK_DOCUMENT_TYPES.DLPCatalyticConverter,
	PAPERWORK_DOCUMENT_TYPES.DLPTotalLossProtection,
	PAPERWORK_DOCUMENT_TYPES.DLPWear,
	PAPERWORK_DOCUMENT_TYPES.DLPService,
	PAPERWORK_DOCUMENT_TYPES.CalTexPaint,
	PAPERWORK_DOCUMENT_TYPES.KahuServiceAgreement,
];

export const REASON_OF_CANCELLATION = {
	CustomerRequest: ReasonOfCancellationEnum.CustomerRequest,
	Refinancing: ReasonOfCancellationEnum.Refinancing,
	TradeInForNewVehicle: ReasonOfCancellationEnum.TradeInForNewVehicle,
	Repossession: ReasonOfCancellationEnum.Repossession,
	VehicleSold: ReasonOfCancellationEnum.VehicleSold,
	TotalLoss: ReasonOfCancellationEnum.TotalLoss,
	TradeInAtDifferentDealership: ReasonOfCancellationEnum.TradeInAtDifferentDealership,
	LenderRequest: ReasonOfCancellationEnum.LenderRequest,
};

export const ReasonOfCancellation = [
	{ value: REASON_OF_CANCELLATION.CustomerRequest, label: 'Customer Request' },
	{ value: REASON_OF_CANCELLATION.Refinancing, label: 'Refinancing' },
	{
		value: REASON_OF_CANCELLATION.TradeInForNewVehicle,
		label: 'Trade-In at Our Dealerships',
	},
	{
		value: REASON_OF_CANCELLATION.TradeInAtDifferentDealership,
		label: 'Trade-In at a Different Dealership',
	},
	{ value: REASON_OF_CANCELLATION.Repossession, label: 'Repossession' },
	{ value: REASON_OF_CANCELLATION.VehicleSold, label: 'Vehicle Sold' },
	{ value: REASON_OF_CANCELLATION.TotalLoss, label: 'Total Loss' },
	{ value: REASON_OF_CANCELLATION.LenderRequest, label: 'Lender Request' },
];

export const CDK_MAPPING_LOCATION = {
	PRODUCTS: CDKMappingLocation.Products,
	FEES: CDKMappingLocation.Fees,
	TAXES: CDKMappingLocation.Taxes,
	WEOWES: CDKMappingLocation.Weowes,
};

export const states = [
	//Mainland US
	{ code: 'AL', description: 'Alabama', isUSTerritory: false },
	{ code: 'AK', description: 'Alaska', isUSTerritory: false },
	{ code: 'AZ', description: 'Arizona', isUSTerritory: false },
	{ code: 'AR', description: 'Arkansas', isUSTerritory: false },
	{ code: 'CA', description: 'California', isUSTerritory: false },
	{ code: 'CO', description: 'Colorado', isUSTerritory: false },
	{ code: 'CT', description: 'Connecticut', isUSTerritory: false },
	{ code: 'DE', description: 'Delaware', isUSTerritory: false },
	{ code: 'DC', description: 'District Of Columbia', isUSTerritory: true },
	{ code: 'FL', description: 'Florida', isUSTerritory: false },
	{ code: 'GA', description: 'Georgia', isUSTerritory: false },
	{ code: 'HI', description: 'Hawaii', isUSTerritory: false },
	{ code: 'ID', description: 'Idaho', isUSTerritory: false },
	{ code: 'IL', description: 'Illinois', isUSTerritory: false },
	{ code: 'IN', description: 'Indiana', isUSTerritory: false },
	{ code: 'IA', description: 'Iowa', isUSTerritory: false },
	{ code: 'KS', description: 'Kansas', isUSTerritory: false },
	{ code: 'KY', description: 'Kentucky', isUSTerritory: false },
	{ code: 'LA', description: 'Louisiana', isUSTerritory: false },
	{ code: 'ME', description: 'Maine', isUSTerritory: false },
	{ code: 'MD', description: 'Maryland', isUSTerritory: false },
	{ code: 'MA', description: 'Massachusetts', isUSTerritory: false },
	{ code: 'MI', description: 'Michigan', isUSTerritory: false },
	{ code: 'MN', description: 'Minnesota', isUSTerritory: false },
	{ code: 'MS', description: 'Mississippi', isUSTerritory: false },
	{ code: 'MO', description: 'Missouri', isUSTerritory: false },
	{ code: 'MT', description: 'Montana', isUSTerritory: false },
	{ code: 'NE', description: 'Nebraska', isUSTerritory: false },
	{ code: 'NV', description: 'Nevada', isUSTerritory: false },
	{ code: 'NH', description: 'New Hampshire', isUSTerritory: false },
	{ code: 'NJ', description: 'New Jersey', isUSTerritory: false },
	{ code: 'NM', description: 'New Mexico', isUSTerritory: false },
	{ code: 'NY', description: 'New York', isUSTerritory: false },
	{ code: 'NC', description: 'North Carolina', isUSTerritory: false },
	{ code: 'ND', description: 'North Dakota', isUSTerritory: false },
	{ code: 'OH', description: 'Ohio', isUSTerritory: false },
	{ code: 'OK', description: 'Oklahoma', isUSTerritory: false },
	{ code: 'OR', description: 'Oregon', isUSTerritory: false },
	{ code: 'PA', description: 'Pennsylvania', isUSTerritory: false },
	{ code: 'RI', description: 'Rhode Island', isUSTerritory: false },
	{ code: 'SC', description: 'South Carolina', isUSTerritory: false },
	{ code: 'SD', description: 'South Dakota', isUSTerritory: false },
	{ code: 'TN', description: 'Tennessee', isUSTerritory: false },
	{ code: 'TX', description: 'Texas', isUSTerritory: false },
	{ code: 'UT', description: 'Utah', isUSTerritory: false },
	{ code: 'VT', description: 'Vermont', isUSTerritory: false },
	{ code: 'VA', description: 'Virginia', isUSTerritory: false },
	{ code: 'WA', description: 'Washington', isUSTerritory: false },
	{ code: 'WV', description: 'West Virginia', isUSTerritory: false },
	{ code: 'WI', description: 'Wisconsin', isUSTerritory: false },
	{ code: 'WY', description: 'Wyoming', isUSTerritory: false },

	{ code: 'AS', description: 'American Samoa', isUSTerritory: true },
	{ code: 'GU', description: 'Guam', isUSTerritory: true },
	{ code: 'MP', description: 'Northern Mariana Islands', isUSTerritory: true },
	{ code: 'PR', description: 'Puerto Rico', isUSTerritory: true },
	{ code: 'VI', description: 'U.S. Virgin Islands', isUSTerritory: true },
];

export const LOG_WHAT = {
	STARTED: LogWhat.Started,
	FINISHED: LogWhat.Finished,
	STEP_STARTED: LogWhat.StepStarted,
	STEP_FINISHED: LogWhat.StepFinished,
	STEP_CHANGED: LogWhat.StepChanged,
	FAILED: LogWhat.Failed,
	DISCONNECTED: LogWhat.Disconnected,
};

export const LOG_HOW = {
	BUTTON: {
		CLICK: 'Button Clicked',
	},
	SECTION: {
		OPENED: 'Section Opened',
		CLOSED: 'Section Closed',
		CHANGED: 'Section Changed',
	},
	ASYNC: {
		STARTED: 'Asyncronous Call Started',
		DONE: 'Asyncronous Call Resolved',
	},
	VIDEO_RECORDING: {
		STARTED: 'Recording Started',
		ONGOING: 'Recording Ongoing',
		DONE: 'Recording Done',
	},
};

export const LOG_WHERE = {
	RATE: 'F&I Rate',
	VIDEO_RECORDING: 'Video Recording',
};

export const FUEL_TYPES = {
	GASOLINE: FuelTypes.Gasoline,
	HYBRID: FuelTypes.Hybrid,
	PLUGIN_HYBRID: FuelTypes.PluginHybrid,
	ELECTRIC: FuelTypes.Electric,
	DIESEL: FuelTypes.Diesel,
	PROPANE: FuelTypes.Propane,
	NATURAL_GAS: FuelTypes.NaturalGas,
	GASOLINE_PROPANE: FuelTypes.GasolinePropane,
	GASOLINE_NATURAL_GAS: FuelTypes.GasolineNaturalGas,
	FLEX_FUEL: FuelTypes.FuelFlex,
	FLEX_FUEL_HYBRID: FuelTypes.FuelFlexHybrid,
	FLEX_FUEL_PLUGIN_HYBRID: FuelTypes.FuelFlexPluginHybrid,
	HYDROGEN: FuelTypes.Hydrogen,
	PLUGIN_HYBRID_FAST_CHARGE: FuelTypes.PluginHybridFastCharge,
};
export const DROPDOWN_SORT_MODE = {
	ASCENDING: DropdownSortMode.Ascending,
	DESCENDING: DropdownSortMode.Descending,
	CUSTOM: DropdownSortMode.Custom,
	ORIGINAL_ORDER: DropdownSortMode.OriginalOrder,
};

export const fuelTypes = [
	{ code: FUEL_TYPES.GASOLINE, description: 'Gasoline' },
	{ code: FUEL_TYPES.HYBRID, description: 'Hybrid' },
	{ code: FUEL_TYPES.PLUGIN_HYBRID, description: 'Plugin Hybrid' },
	{ code: FUEL_TYPES.ELECTRIC, description: 'Electric' },
	{ code: FUEL_TYPES.DIESEL, description: 'Diesel' },
	{ code: FUEL_TYPES.PROPANE, description: 'Propane' },
	{ code: FUEL_TYPES.NATURAL_GAS, description: 'Natural Gas' },
	{ code: FUEL_TYPES.GASOLINE_PROPANE, description: 'Gasoline Propane' },
	{
		code: FUEL_TYPES.GASOLINE_NATURAL_GAS,
		description: 'Gasoline Natural Gas',
	},
	{ code: FUEL_TYPES.FLEX_FUEL, description: 'Flex Fuel' },
	{ code: FUEL_TYPES.FLEX_FUEL_HYBRID, description: 'Flex Fuel Hybrid' },
	{
		code: FUEL_TYPES.FLEX_FUEL_PLUGIN_HYBRID,
		description: 'Flex Fuel Plugin Hybrid',
	},
	{ code: FUEL_TYPES.HYDROGEN, description: 'Hydrogen' },
	{
		code: FUEL_TYPES.PLUGIN_HYBRID_FAST_CHARGE,
		description: 'Plugin Hybrid Fast Charge',
	},
];
export const bodyTypes = [
	{ code: BodyTypes.SUV, description: 'SUV' },
	{ code: BodyTypes.Minivan, description: 'Minivan' },
	{ code: BodyTypes.CargoVan, description: 'Cargo Van' },
	{ code: BodyTypes.FourDoorSedan, description: '4 Door Sedan' },
	{ code: BodyTypes.StationWagon, description: 'Station Wagon' },
	{ code: BodyTypes.TwoDoorCoupe, description: '2 Door Coupe' },
	{ code: BodyTypes.Convertible, description: 'Convertible' },
	{ code: BodyTypes.Hatchback, description: 'Hatchback' },
	{ code: BodyTypes.ThreeDoorCar, description: '3 Door Car' },
	{ code: BodyTypes.RegularCabPickup, description: 'Regular Cab Pickup' },
	{
		code: BodyTypes.RegularCabChassisCab,
		description: 'Regular Cab + Chassis',
	},
	{ code: BodyTypes.ExtendedCabPickup, description: 'Extended Cab Pickup' },
	{
		code: BodyTypes.ExtendedCabChassisCab,
		description: 'Extended Cab + Chassis',
	},
	{ code: BodyTypes.CrewCabPickup, description: 'Crew Cab Pickup' },
	{ code: BodyTypes.CrewCabChassisCab, description: 'Crew Cab Chassis Cab' },
	{
		code: BodyTypes.FullSizePassengerVan,
		description: 'Full Size Passenger Van',
	},
	{ code: BodyTypes.FullSizeCargoVan, description: 'Full Size Cargo Van' },
	{ code: BodyTypes.SpecialtyVehicle, description: 'Specialty Vehicle' },
	{ code: BodyTypes.StepsideBed, description: 'Stepside Bed' },
	{ code: BodyTypes.LongBedTruck, description: 'Long Bed Truck' },
	{ code: BodyTypes.ShortBedTruck, description: 'Short Bed Truck' },
	{ code: BodyTypes.StandardBedTruck, description: 'Standard Bed Truck' },
];
export const bodyTypeDropdownList = bodyTypes.map(({ code, description }) => ({
	value: code,
	display: description,
}));

export const addressType = [
	// Adding new address types will create them in the insurance/registration tab. Except types customer and co-customer.
	{
		type: AddressType.Mail,
		description: 'Mailing Address',
		validationQuestion: 'mailingQuestion',
	},
	{
		type: AddressType.Registration,
		description: 'Registration Address',
		validationQuestion: 'registrationQuestion',
	},
	{
		type: AddressType.Garage,
		description: 'Garaging Address',
		validationQuestion: 'garagingQuestion',
	},
	{ type: AddressType.Customer, description: 'Customer Address' },
	{ type: AddressType.CoCustomer, description: 'Co-Customer Address' },
	{ type: AddressType.Lender, description: 'Lender Address' },
];

export const addressTypeEnum = {
	MAILING_ADDRESS: AddressType.Mail,
	REGISTRATION_ADDRESS: AddressType.Registration,
	GARAGING_ADDRESS: AddressType.Garage,
	CUSTOMER_ADDRESS: AddressType.Customer,
	COCUSTOMER_ADDRESS: AddressType.CoCustomer,
	LENDER_ADDRESS: AddressType.Lender,
};

export const PARTNER_PAPERWORK_METHODS = {
	DEFAULT: PartnerPaperworkMethod.Default,
	INTERNAL: PartnerPaperworkMethod.Internal,
	API: PartnerPaperworkMethod.API,
	INTERNAL_AND_API: PartnerPaperworkMethod.InternalAndAPI,
};

export const partnerPaperworkMethods = [
	{ code: PARTNER_PAPERWORK_METHODS.DEFAULT, name: 'Default' },
	{ code: PARTNER_PAPERWORK_METHODS.INTERNAL, name: 'Internal' },
	{ code: PARTNER_PAPERWORK_METHODS.API, name: 'API' },
	{
		code: PARTNER_PAPERWORK_METHODS.INTERNAL_AND_API,
		name: 'Internal and API',
	},
];

export const VEHICLE_MILEAGE_STATUS = {
	ACTUAL_MILEAGE: VehicleMileageStatus.ActualMileage,
	EXCESS_OF_MECHANICAL_LIMITS: VehicleMileageStatus.ExcessOfMechanicalLimits,
	NOT_ACTUAL_MILEAGE: VehicleMileageStatus.NotActualMileage,
	toList: () => [
		{ value: VEHICLE_MILEAGE_STATUS.ACTUAL_MILEAGE, display: 'ACTUAL MILEAGE' },
		{
			value: VEHICLE_MILEAGE_STATUS.EXCESS_OF_MECHANICAL_LIMITS,
			display: 'EXCESS OF MECHANICAL LIMITS',
		},
		{
			value: VEHICLE_MILEAGE_STATUS.NOT_ACTUAL_MILEAGE,
			display: 'NOT ACTUAL MILEAGE',
		},
	],
	getDisplay: value => VEHICLE_MILEAGE_STATUS.toList().find(v => v.value === value)?.display,
};

export const VEHICLE_PRIMARY_USAGE = {
	PERONSAL: VehiclePrimaryUsage.Personal,
	FAMILY: VehiclePrimaryUsage.Family,
	HOUSEHOLD: VehiclePrimaryUsage.Household,
	BUSINESS: VehiclePrimaryUsage.Business,
	AGRICULTURAL: VehiclePrimaryUsage.Agricultural,
	OTHER: VehiclePrimaryUsage.Other,
	toList: () => [
		{ value: VEHICLE_PRIMARY_USAGE.PERSONAL, display: 'PERSONAL' },
		{ value: VEHICLE_PRIMARY_USAGE.FAMILY, display: 'FAMILY' },
		{ value: VEHICLE_PRIMARY_USAGE.HOUSEHOLD, display: 'HOUSEHOLD' },
		{ value: VEHICLE_PRIMARY_USAGE.BUSINESS, display: 'BUSINESS' },
		{ value: VEHICLE_PRIMARY_USAGE.AGRICULTURAL, display: 'AGRICULTURAL' },
		{ value: VEHICLE_PRIMARY_USAGE.OTHER, display: 'OTHER' },
	],
	getDisplay: value => VEHICLE_PRIMARY_USAGE.toList().find(v => v.value === value)?.display,
};

export const VEHICLE_SURCHARGES = {
	COMMERCIAL: VehicleSurcharges.Commercial,
	LIFT_KIT: VehicleSurcharges.LiftKit,
	FOUR_WHEEL_DRIVE: VehicleSurcharges.FourWheelDrive,
	SUPERCHARGED: VehicleSurcharges.Supercharged,
	TURBO: VehicleSurcharges.Turbo,
};

export const otherVehicleInfo = [
	{ key: 'WheelSizeFront', display: 'Wheel Size Front' },
	{ key: 'WheelSizeRear', display: 'Wheel Size Rear' },
	{ key: 'TreadWidth', display: 'Tread Width' },
	{ key: 'MotorcycleCC', display: 'Motorcycle CC' },
	{ key: 'HorsePower', display: 'Horse Power' },
	{ key: 'Cylinders', display: 'Cylinders' },
	{ key: 'NumberOfTires', display: 'Number Of Tires' },
	{ key: 'TirePrice', display: 'Tire Price' },
	{ key: 'Length', display: 'Length (IN)' },
	{ key: 'Weight', display: 'Weight (LB)' },
	{ key: 'GVWR', display: 'GVWR' },
	{ key: 'CurbWeight', display: 'Curb Weight (LB)' },
	{ key: 'MPGCity', display: 'MPG City' },
	{ key: 'MPGHighway', display: 'MPG Highway' },
	{ key: 'MPGCombined', display: 'MPG Combined' },
	{ key: 'GTW', display: 'GTW' },
	{ key: 'PayLoadCapacity', display: 'Payload Capacity' },
	{ key: 'EngineDescription', display: 'Engine' },
	{ key: 'TransmissionDescription', display: 'Transmission' },
];

export const WARRANTY_EXPIRATION_DATE_RULES = {
	TODAY: WarrantyExpirationDateRules.Today,
	IN_SERVICE_DATE: WarrantyExpirationDateRules.InServiceDate,
	MODEL_YEAR: WarrantyExpirationDateRules.ModelYear,
};

export const EXTERNAL_DMS_SOURCE = {
	CDK: ExternalDMSSourceEnum.CDK,
	Reynolds: ExternalDMSSourceEnum.Reynolds,
	Other: ExternalDMSSourceEnum.Other,
	toList: () => [
		{ value: EXTERNAL_DMS_SOURCE.CDK, display: 'CDK' },
		{ value: EXTERNAL_DMS_SOURCE.Reynolds, display: 'Reynolds' },
		{ value: EXTERNAL_DMS_SOURCE.Other, display: 'Other' },
	],
};

export const WARRANTY_EXPIRATION_MILES_RULES = {
	NO_EXPIRATION: WarrantyExpirationMilesRules.NoExpiration,
	FROM_ODOMETER: WarrantyExpirationMilesRules.FromOdometer,
	FROM_ZERO: WarrantyExpirationMilesRules.FromZero,
};

export const CREDIT_APP_RESIDENCE_STATUS = {
	MORTGAGE: CreditAppResidenceStatus.Mortgage,
	Rental: CreditAppResidenceStatus.Rental,
	OWN: CreditAppResidenceStatus.Own,
	OTHER: CreditAppResidenceStatus.Other,
};

export const CREDIT_APP_RESIDENCE_STATUS_TITLE = {
	1: 'is Mortgage',
	2: 'is Rental',
	3: 'Own Home Outright',
	4: 'Family/Other',
};

export const CREDIT_APP_EMPLOYMENT_STATUS = {
	EMPLOYEE: CreditAppEmploymentStatus.Employee,
	RETIRED: CreditAppEmploymentStatus.Retired,
	STUDENT: CreditAppEmploymentStatus.Student,
	UNEMPLOYED: CreditAppEmploymentStatus.Unemployed,
	OTHER: CreditAppEmploymentStatus.Other,
};
// Do not use
export const CREDIT_APP_EMPLOYMENT_STATUS_TITLE = {
	1: 'Employee',
	2: 'Retired',
	3: 'Student',
	4: 'Unemployed',
	5: 'Other',
};
//Do not use
export const CREDIT_APP_TYPE_EMPLOYEE = {
	MILITARY: CreditAppTypeEmployee.Military,
	W2: CreditAppTypeEmployee.W2,
	SE1099: CreditAppTypeEmployee.SE1099,
};

export const CREDIT_APP_TYPE_EMPLOYEE_TITLE = {
	1: 'Employed by the Military',
	2: 'W2 Employed',
	3: 'Self Employed or 1099 Employed',
};

export const CUSTOMER_APPLICATION_EMPLOYMENT_STATUS = {
	EMPLOYED: CustomerApplicationEmploymentStatus.Employed,
	RETIRED: CustomerApplicationEmploymentStatus.Retired,
	DISABLED: CustomerApplicationEmploymentStatus.Disabled,
	STUDENT: CustomerApplicationEmploymentStatus.Student,
	UNEMPLOYED: CustomerApplicationEmploymentStatus.Unemployed,
	OTHER: CustomerApplicationEmploymentStatus.Other,
};

export const CUSTOMER_APPLICATION_EMPLOYMENT_TITLE = [
	{
		value: CUSTOMER_APPLICATION_EMPLOYMENT_STATUS.EMPLOYED,
		English: 'Employed',
		Spanish: 'Employed',
	},
	{
		value: CUSTOMER_APPLICATION_EMPLOYMENT_STATUS.RETIRED,
		English: 'Retired',
		Spanish: 'Retirado(a)',
	},
	{
		value: CUSTOMER_APPLICATION_EMPLOYMENT_STATUS.DISABLED,
		English: 'Disabled',
		Spanish: 'Desabilitado(a)',
	},
	{
		value: CUSTOMER_APPLICATION_EMPLOYMENT_STATUS.STUDENT,
		English: 'Student',
		Spanish: 'Estudiante',
	},
	{
		value: CUSTOMER_APPLICATION_EMPLOYMENT_STATUS.UNEMPLOYED,
		English: 'Unemployed',
		Spanish: 'Desempleado(a)',
	},
	{
		value: CUSTOMER_APPLICATION_EMPLOYMENT_STATUS.OTHER,
		English: 'Other',
		Spanish: 'Otro',
	},
];

export const CUSTOMER_APPLICATION_HOUSING_STATUS = {
	MORTGAGE: CustomerApplicationHousingStatus.Mortgage,
	RENTAL: CustomerApplicationHousingStatus.Rental,
	OWN: CustomerApplicationHousingStatus.Own,
	OTHER: CustomerApplicationHousingStatus.Other,
};

export const CUSTOMER_APPLICATION_HOUSING_TITLE = [
	{
		value: CUSTOMER_APPLICATION_HOUSING_STATUS.MORTGAGE,
		English: 'Mortgage',
		Spanish: 'Hipoteco',
	},
	{
		value: CUSTOMER_APPLICATION_HOUSING_STATUS.RENTAL,
		English: 'Rental',
		Spanish: 'Alquilo',
	},
	{
		value: CUSTOMER_APPLICATION_HOUSING_STATUS.OWN,
		English: 'Own',
		Spanish: 'Poseo',
	},
	{
		value: CUSTOMER_APPLICATION_HOUSING_STATUS.OTHER,
		English: 'Living With Family/Other',
		Spanish: 'Viviendo Con Familiares/Otros',
	},
];

export const CUSTOMER_APPLICATION_ENTERPRISE_TYPE = {
	LLC: CustomerApplicationEnterpriseType.LLC,
	CORPORATION: CustomerApplicationEnterpriseType.Corporation,
	PARTNERSHIP: CustomerApplicationEnterpriseType.Partnership,
	PROPRIETOR: CustomerApplicationEnterpriseType.Proprietor,
	toList: () => [
		{ display: 'LLC', value: CUSTOMER_APPLICATION_ENTERPRISE_TYPE.LLC },
		{
			display: 'CORPORATION',
			value: CUSTOMER_APPLICATION_ENTERPRISE_TYPE.CORPORATION,
		},
		{
			display: 'PARTNERSHIP',
			value: CUSTOMER_APPLICATION_ENTERPRISE_TYPE.PARTNERSHIP,
		},
		{
			display: 'PROPRIETOR',
			value: CUSTOMER_APPLICATION_ENTERPRISE_TYPE.PROPRIETOR,
		},
	],
};

export const DEAL_TYPES = {
	CASH: DealTypeEnum.Cash,
	FINANCE: DealTypeEnum.Finance,
	LEASE: DealTypeEnum.Lease,
	toList: () => [
		{ display: 'Cash', value: DEAL_TYPES.CASH },
		{ display: 'Finance', value: DEAL_TYPES.FINANCE },
		{ display: 'Lease', value: DEAL_TYPES.LEASE },
	],
	getDisplay: DEALTYPE => DEAL_TYPES.toList().find(f => f.value === DEALTYPE)?.display,
};

export const CDK_DEAL_STATUS = {
	Unknown: CDKDealStatus.Unknown,
	Booked: CDKDealStatus.Booked, //B
	Cancelled: CDKDealStatus.Cancelled, //C
	Finalized: CDKDealStatus.Finalized, //F
	Intermediate: CDKDealStatus.Intermediate, //I
	Pending: CDKDealStatus.Pending, //P
	Unwind: CDKDealStatus.Unwind, //U
	getCDKStatusCode: status => {
		switch (status) {
			case CDK_DEAL_STATUS.Booked:
				return 'B';
			case CDK_DEAL_STATUS.Cancelled:
				return 'C';
			case CDK_DEAL_STATUS.Finalized:
				return 'F';
			case CDK_DEAL_STATUS.Intermediate:
				return 'I';
			case CDK_DEAL_STATUS.Pending:
				return 'P';
			case CDK_DEAL_STATUS.Unwind:
				return 'U';
			default:
				return null;
		}
	},
};

export const CREDIT_APP_BUTTONS_ACTIONS = {
	SAVE_ANSWER: CreditAppButtonsActions.SaveAnswer,
	NEXT_QUESTION: CreditAppButtonsActions.NextQuestion,
	SAVE_MULTI_ANSWER: CreditAppButtonsActions.SaveMultiAnswer,
	CALL_API: CreditAppButtonsActions.CallApi,
	SAVE_FULL_APPLICATION: CreditAppButtonsActions.SaveFullApplication,
};

export const CUSTOMER_IDENTIFICATION_TYPES = {
	DriversLicense: CustomerIdentificationTypes.DriversLicense,
	InsuranceId: CustomerIdentificationTypes.InsuranceId,
	Passport: CustomerIdentificationTypes.Passport,
	GovernmentAgencyId: CustomerIdentificationTypes.GovernmentAgencyId,
	SchoolId: CustomerIdentificationTypes.SchoolId,
	TeacherId: CustomerIdentificationTypes.TeacherId,
	MilitaryId: CustomerIdentificationTypes.MilitaryId,
	VeteranId: CustomerIdentificationTypes.VeteranId,
	EmployeeId: CustomerIdentificationTypes.EmployeeId,
	UnionId: CustomerIdentificationTypes.UnionId,
	AssociationId: CustomerIdentificationTypes.AssociationId,
	VehicleRegistration: CustomerIdentificationTypes.VehicleRegistration,
	UtilityBill: CustomerIdentificationTypes.UtilityBill,
	PayStub: CustomerIdentificationTypes.PayStub,
	SocialSecurityCard: CustomerIdentificationTypes.SocialSecurityCard,
	GreenCard: CustomerIdentificationTypes.GreenCard,
	ResidentAlienCard: CustomerIdentificationTypes.ResidentAlienCard,
};

export const DEAL_EMPLOYEE_ROLE_TYPES = {
	SALES_MANAGER: DealEmployeeRoleTypes.SalesManager,
	SALES_PERSON1: DealEmployeeRoleTypes.SalesPerson1,
	FLOOR_CLOSER: DealEmployeeRoleTypes.FloorCloser,
	SALES_PERSON2: DealEmployeeRoleTypes.SalesPerson2,
	FI_MANAGER: DealEmployeeRoleTypes.FiManager,
	AFTER_MARKET_SALES_MANAGER: DealEmployeeRoleTypes.AfterMarketSalesManager,
	AFTER_MARKET_SALES_PERSON: DealEmployeeRoleTypes.AfterMarketSalesPerson,
	COSTING_CLERK: DealEmployeeRoleTypes.CostingClerk,
	ACCOUNTING_MANAGER: DealEmployeeRoleTypes.AccountingManager,
	CONTROLLER: DealEmployeeRoleTypes.Controller,
	RIPPER: DealEmployeeRoleTypes.Ripper,
};

export const dealEmployeeRoleTypes = [
	{ key: DEAL_EMPLOYEE_ROLE_TYPES.SALES_MANAGER, description: 'Sales Manager' },
	{
		key: DEAL_EMPLOYEE_ROLE_TYPES.SALES_PERSON1,
		description: 'Sales Person 1',
	},
	{ key: DEAL_EMPLOYEE_ROLE_TYPES.FLOOR_CLOSER, description: 'Floor Closer' },
	{
		key: DEAL_EMPLOYEE_ROLE_TYPES.SALES_PERSON2,
		description: 'Sales Person 2',
	},
	{ key: DEAL_EMPLOYEE_ROLE_TYPES.FI_MANAGER, description: 'F&I Manager' },
	{
		key: DEAL_EMPLOYEE_ROLE_TYPES.AFTER_MARKET_SALES_MANAGER,
		description: 'After Market Sales Manager',
	},
	{
		key: DEAL_EMPLOYEE_ROLE_TYPES.AFTER_MARKET_SALES_PERSON,
		description: 'After Market Sales Person',
	},
	{ key: DEAL_EMPLOYEE_ROLE_TYPES.COSTING_CLERK, description: 'Costing Clerk' },
	{
		key: DEAL_EMPLOYEE_ROLE_TYPES.ACCOUNTING_MANAGER,
		description: 'Accounting Mananger',
	},
	{ key: DEAL_EMPLOYEE_ROLE_TYPES.CONTROLLER, description: 'Controller' },
	{ key: DEAL_EMPLOYEE_ROLE_TYPES.RIPPER, description: 'F&I Admin' },
];

export const PRICING_PLAN_SELECTORS = {
	OTHER: PricingPlanSelectors.Other,
	HIGHEST_PRICE: PricingPlanSelectors.HighestPrice,
	LOWEST_PRICE: PricingPlanSelectors.LowestPrice,
};

export const pricingPlanSelectors = [
	{ code: PRICING_PLAN_SELECTORS.HIGHEST_PRICE, display: 'Highest Price' },
	{ code: PRICING_PLAN_SELECTORS.LOWEST_PRICE, display: 'Lowest Price' },
];

export const PRICING_LIST_OPTION_PRICE_SPLITS = {
	HIGHEST_BETWEEN: PricingListOptionPriceSplits.HighestBetween,
	LOWEST_BETWEEN: PricingListOptionPriceSplits.LowestBetween,
};

export const pricingListOptionPriceSplits = [
	{
		code: PRICING_LIST_OPTION_PRICE_SPLITS.HIGHEST_BETWEEN,
		display: 'Highest Between',
	},
	{
		code: PRICING_LIST_OPTION_PRICE_SPLITS.LOWEST_BETWEEN,
		display: 'Lowest Between',
	},
];

export const PROFIT_FLAGS = {
	FRONT: ProfitFlags.Front,
	BACK: ProfitFlags.Back,
	DEALER: ProfitFlags.Dealer,
	NONE: ProfitFlags.None,
	defaultForProducts: () => PROFIT_FLAGS.BACK,
	defaultForAdditions: () => PROFIT_FLAGS.FRONT,
	getDesc: PROFIT_FLAG => PROFIT_FLAGS.toList().find(f => f.value === PROFIT_FLAG)?.text,
	toList: () => [
		{ text: 'Front', value: PROFIT_FLAGS.FRONT },
		{ text: 'Back', value: PROFIT_FLAGS.BACK },
		{ text: 'Dealer', value: PROFIT_FLAGS.DEALER },
		{ text: 'None', value: PROFIT_FLAGS.NONE },
	],
};

export const PROFIT_METHODS = {
	AMOUNT_MINUS_COST: ProfitMethods.AmountMinusCost,
	COST_MINUS_AMOUNT: ProfitMethods.CostMinusAmount,
};

export const ADDITION_TYPES = {
	PHYSICAL_ADDITION: AdditionTypes.PhysicalAddition,
	MONETARY_ADDITION: AdditionTypes.MonetaryAddition,
	OTHER: AdditionTypes.Other,
	toList: () => [
		{ display: 'Physical Addition', value: ADDITION_TYPES.PHYSICAL_ADDITION },
		{ display: 'Monetary Addition', value: ADDITION_TYPES.MONETARY_ADDITION },
		{ display: 'Other', value: ADDITION_TYPES.OTHER },
	],
	getDisplay: ADDITION_TYPE => ADDITION_TYPES.toList().find(f => f.value === ADDITION_TYPE)?.display,
};

export const VEHICLE_DELIVERY_METHODS = {
	DELIVERY: VehicleDeliveryMethods.Delivery,
	DRIVEN_OFF_LOT: VehicleDeliveryMethods.DrivenOffLot,
	DELIVERY_OUT_OF_STATE: VehicleDeliveryMethods.DeliveryOutOfState,
	EXPORT: VehicleDeliveryMethods.Export,
	toList: () => [
		{
			display: 'Driven Off Lot',
			value: VEHICLE_DELIVERY_METHODS.DRIVEN_OFF_LOT,
		},
		{ display: 'Delivery In-State', value: VEHICLE_DELIVERY_METHODS.DELIVERY },
		{
			display: 'Delivery Out-of-State',
			value: VEHICLE_DELIVERY_METHODS.DELIVERY_OUT_OF_STATE,
		},
		{ display: 'Export', value: VEHICLE_DELIVERY_METHODS.EXPORT },
	],
	getDisplay: VALUE => VEHICLE_DELIVERY_METHODS.toList().find(f => f.value === VALUE)?.display,
};

export const PayoffQuoteInquiryTypeProductType = {
	Retail: PayoffQuoteInquiryTypeProductTypeEnum.Retail,
	Lease: PayoffQuoteInquiryTypeProductTypeEnum.Lease,
	Balloon: PayoffQuoteInquiryTypeProductTypeEnum.Balloon,
};

export const PayoffQuoteInquiryTypeInquiryType = {
	ACC: PayoffQuoteInquiryTypeInquiryTypeEnum.ACC,
	SSN: PayoffQuoteInquiryTypeInquiryTypeEnum.SSN,
	VIN: PayoffQuoteInquiryTypeInquiryTypeEnum.VIN,
};

export const RATING_STATUS = {
	UP_TO_DATE: RatingStatus.UpToDate,
	REQUIRED: RatingStatus.Required,
	REQUIRED_WITH_SURCHARGE_CHANGE: RatingStatus.RequiredWithSurchargeChange,
};

export const TEXT_MESSAGING_PROVIDERS = {
	TWILIO: TextMessagingProviders.Twilio,
	DIAL_PAD: TextMessagingProviders.DialPad,
};

export const textMessagingProviders = [
	{ value: TEXT_MESSAGING_PROVIDERS.TWILIO, display: 'Twilio' },
	{ value: TEXT_MESSAGING_PROVIDERS.DIAL_PAD, display: 'Dial Pad' },
];

export const CANCEL_COVERAGE_STATUS = {
	UNDEFINED: CancelCoverageStatus.Undefined,
	CANCELLATION_REQUESTED: CancelCoverageStatus.CancellationRequested,
	VIDEOS_WATCHED_SOME: CancelCoverageStatus.VideosWatchedSome,
	VIDEOS_WATCHED_ALL: CancelCoverageStatus.VideosWatchedAll,
	PACKET_RECEIVED: CancelCoverageStatus.PacketReceived,
	PACKET_SUBMITTED: CancelCoverageStatus.PacketSubmitted,
	CANCELLATION_PACKET_INCOMPLETE: CancelCoverageStatus.CancellationPacketIncomplete,
	CANCELLATION_PACKET_RECEIVED: CancelCoverageStatus.CancellationPacketReceived,
	CANCELLATION_PROCESSED: CancelCoverageStatus.CancellationProcessed,
	CANCELLATION_COMPLETED: CancelCoverageStatus.CancellationCompleted,
	REFUND_SENT: CancelCoverageStatus.RefundSent,
};

export const CANCEL_COVERAGE_APPLY_FUNDS_TO = {
	ToLienholder: CancelCoverageApplyFundsTo.ToLienholder,
	TowardsDownPayment: CancelCoverageApplyFundsTo.TowardsDownPayment,
	ToCustomer: CancelCoverageApplyFundsTo.ToCustomer,
};

export const AUDIT_TRAIL_OPERATIONS = {
	INSERT: AuditTrailOperations.Insert,
	UPDATE: AuditTrailOperations.Update,
	DELETE: AuditTrailOperations.Delete,
};

export const CUSTOMER_DOCUMENT_TYPE = {
	Identification: CustomerDocumentType.Identification,
	Income: CustomerDocumentType.Income,
	Rebate: CustomerDocumentType.Rebate,
	Other: CustomerDocumentType.Other,
};

export const CUSTOMER_DOCUMENT_SUBTYPE = {
	DriversLicense: CustomerDocumentSubtype.DriversLicense,
	InsuranceId: CustomerDocumentSubtype.InsuranceId,
	Passport: CustomerDocumentSubtype.Passport,
	GovernmentAgencyId: CustomerDocumentSubtype.GovernmentAgencyId,
	SchoolId: CustomerDocumentSubtype.SchoolId,
	TeacherId: CustomerDocumentSubtype.TeacherId,
	MilitaryId: CustomerDocumentSubtype.MilitaryId,
	VeteranId: CustomerDocumentSubtype.VeteranId,
	EmployeeId: CustomerDocumentSubtype.EmployeeId,
};

export const DEAL_ROOM_STATE = {
	DoesntExist: DealRoomState.DoesntExist,
	EditorVacancy: DealRoomState.EditorVacancy,
	ActiveEditor: DealRoomState.ActiveEditor,
};

export const DEAL_GOAL_TYPES = {
	PRODUCT_COUNT: DealGoalTypes.ProductCount,
	PACKAGE_COUNT: DealGoalTypes.PackageCount,
	PRODUCT_PROFIT: DealGoalTypes.ProductProfit,
};

export const DEAL_LOJACK_STATUS = {
	INSTALLED: DealLoJackStatus.Installed,
	NEEDS_ACTIVATION: DealLoJackStatus.NeedsActivation,
	NOT_INSTALLED: DealLoJackStatus.NotInstalled,
	UNKNOWN: DealLoJackStatus.Unknown,
};

export const COMPARISON_TYPE = {
	MINIMUM: ComparisonType.Minimum,
	TWEEN: ComparisonType.Tween,
	MAXIMUM: ComparisonType.Maximum,
};

export const RT_FILE_TYPES = {
	EXCEL: RTFileType.Excel,
	PDF: RTFileType.Pdf,
	CSV: RTFileType.Csv,
};

// Disabled products commented out
export const PLAID_PRODUCTS = {
	Assets: PlaidProducts.Assets,
	Auth: PlaidProducts.Auth,
	Identity: PlaidProducts.Identity,
	//Investments: 'investments',
	//PaymentInitiation: 'payment_initiation',
	IdentityVerification: PlaidProducts.IdentityVerification,
	//Transactions: 'transactions',
	Transfer: PlaidProducts.Transfer,
	IncomeVerification: PlaidProducts.IncomeVerification,
	Statements: PlaidProducts.Statements,
};

export const PLAID_LANGUAGES = {
	Danish: PlaidLanguages.Danish,
	Dutch: PlaidLanguages.Dutch,
	English: PlaidLanguages.English,
	Estonian: PlaidLanguages.Estonian,
	French: PlaidLanguages.French,
	German: PlaidLanguages.German,
	Italian: PlaidLanguages.Italian,
	Latvian: PlaidLanguages.Latvian,
	Lithuanian: PlaidLanguages.Lithuanian,
	Norwegian: PlaidLanguages.Norwegian,
	Polish: PlaidLanguages.Polish,
	Portuguese: PlaidLanguages.Portuguese,
	Romanian: PlaidLanguages.Romanian,
	Spanish: PlaidLanguages.Spanish,
	Swedish: PlaidLanguages.Swedish,
};

export const PLAID_COUNTRIES = {
	UnitedStates: PlaidCountries.UnitedStates,
	Canada: PlaidCountries.Canada,
};

export const PLAID_ID_TYPES = {
	ArgentinaDNI: PlaidIdTypes.ArgentinaDNI,
	AustraliaDrivers: PlaidIdTypes.AustraliaDrivers,
	AustraliaPassport: PlaidIdTypes.AustraliaPassport,
	BrazilCPF: PlaidIdTypes.BrazilCPF,
	CanadaSIN: PlaidIdTypes.CanadaSIN,
	ChileRUN: PlaidIdTypes.ChileRUN,
	ChinaResident: PlaidIdTypes.ChinaResident,
	ColombiaNIT: PlaidIdTypes.ColombiaNIT,
	DenmarkCPR: PlaidIdTypes.DenmarkCPR,
	EgyptNationalID: PlaidIdTypes.EgyptNationalID,
	SpainDNI: PlaidIdTypes.SpainDNI,
	SpainNIE: PlaidIdTypes.SpainNIE,
	HongKongHKID: PlaidIdTypes.HongKongHKID,
	IndiaPAN: PlaidIdTypes.IndiaPAN,
	ItalyCF: PlaidIdTypes.ItalyCF,
	JordanCivilID: PlaidIdTypes.JordanCivilID,
	JapanMyNumber: PlaidIdTypes.JapanMyNumber,
	KenyaHudumaNamba: PlaidIdTypes.KenyaHudumaNamba,
	KuwaitCivilID: PlaidIdTypes.KuwaitCivilID,
	MexicoCURP: PlaidIdTypes.MexicoCURP,
	MexicoRFC: PlaidIdTypes.MexicoRFC,
	MalaysiaNRIC: PlaidIdTypes.MalaysiaNRIC,
	NigeriaNIN: PlaidIdTypes.NigeriaNIN,
	NewZealandDrivers: PlaidIdTypes.NewZealandDrivers,
	OmanCivilID: PlaidIdTypes.OmanCivilID,
	PhilippinesPSN: PlaidIdTypes.PhilippinesPSN,
	PolandPESEL: PlaidIdTypes.PolandPESEL,
	RomaniaCNP: PlaidIdTypes.RomaniaCNP,
	SaudiArabiaNationalID: PlaidIdTypes.SaudiArabiaNationalID,
	SwedenPIN: PlaidIdTypes.SwedenPIN,
	Singapore: PlaidIdTypes.Singapore,
	TurkiyeKimlik: PlaidIdTypes.TurkiyeKimlik,
	UnitedStatesSSN: PlaidIdTypes.UnitedStatesSSN,
	UnitedStatesSSNLast4: PlaidIdTypes.UnitedStatesSSNLast4,
	SouthAfricaSmartID: PlaidIdTypes.SouthAfricaSmartID,
};

export const PLAID_INCOME_TYPE = {
	Bank: PlaidIncomeType.Bank,
	Payroll: PlaidIncomeType.Payroll,
};

export const PLAID_PAYROLL_FLOW = {
	DigitalIncome: PlaidPayrollFlow.DigitalIncome,
	DocumentIncome: PlaidPayrollFlow.DocumentIncome,
};

export const PLAID_INCOME_SOURCE = {
	Salary: PlaidIncomeSource.Salary,
	Unemployement: PlaidIncomeSource.Unemployement,
	Cash: PlaidIncomeSource.Cash,
	GigEconomy: PlaidIncomeSource.GigEconomy,
	Rental: PlaidIncomeSource.Rental,
	ChildSupport: PlaidIncomeSource.ChildSupport,
	Military: PlaidIncomeSource.Military,
	Retirement: PlaidIncomeSource.Retirement,
	LongTermDisability: PlaidIncomeSource.LongTermDisability,
	BankInterest: PlaidIncomeSource.BankInterest,
	CashDeposit: PlaidIncomeSource.CashDeposit,
	TransferFromApplication: PlaidIncomeSource.TransferFromApplication,
	TaxRefund: PlaidIncomeSource.TaxRefund,
	BenefitOther: PlaidIncomeSource.BenefitOther,
	Other: PlaidIncomeSource.Other,
};

export const PLAID_PAY_TYPE = {
	Unknown: PlaidPayType.Unknown,
	Gross: PlaidPayType.Gross,
	Net: PlaidPayType.Net,
};

export const PLAID_PAY_FREQUENCY = {
	Unknown: PlaidPayFrequency.Unknown,
	Weekly: PlaidPayFrequency.Weekly,
	Biweekly: PlaidPayFrequency.Biweekly,
	SemiMonthly: PlaidPayFrequency.SemiMonthly,
	Monthly: PlaidPayFrequency.Monthly,
	Daily: PlaidPayFrequency.Daily,
};

// Note: Customer Class uses numerical index. Plaid IDV objects use string keys.
export const PLAID_VERIFICATION_STATUS = {
	Active: { ind: PlaidVerificationStatus.Active, str: 'active' },
	Success: { ind: PlaidVerificationStatus.Success, str: 'success' },
	Failed: { ind: PlaidVerificationStatus.Failed, str: 'failed' },
	Expired: { ind: PlaidVerificationStatus.Expired, str: 'expired' },
	Canceled: { ind: PlaidVerificationStatus.Canceled, str: 'canceled' },
	PendingReview: {
		ind: PlaidVerificationStatus.PendingReview,
		str: 'pending_review',
	},
	toList: () => [
		{
			ind: PlaidVerificationStatus.Active,
			value: 'active',
			display: 'In Progress',
		},
		{
			ind: PlaidVerificationStatus.Success,
			value: 'success',
			display: 'Approved',
		},
		{
			ind: PlaidVerificationStatus.Failed,
			value: 'failed',
			display: 'Rejected',
		},
		{
			ind: PlaidVerificationStatus.Expired,
			value: 'expired',
			display: 'Expired',
		},
		{
			ind: PlaidVerificationStatus.Canceled,
			value: 'canceled',
			display: 'Canceled',
		},
		{
			ind: PlaidVerificationStatus.PendingReview,
			value: 'pending_review',
			display: 'Pending Review',
		},
	],
	getDisplay: value => PLAID_VERIFICATION_STATUS.toList().find(v => v.value === value || v.ind === value)?.display,
	indexToString: ind => PLAID_VERIFICATION_STATUS.toList().find(v => v.ind === ind)?.value,
	stringToIndex: str => PLAID_VERIFICATION_STATUS.toList().find(v => v.value === str)?.ind,
};

export const PLAID_IDV_STEP_STATUS = {
	Success: PlaidIdvStepStatus.Success,
	Active: PlaidIdvStepStatus.Active,
	Failed: PlaidIdvStepStatus.Failed,
	WaitingForPrerequisite: PlaidIdvStepStatus.WaitingForPrerequisite,
	NotApplicable: PlaidIdvStepStatus.NotApplicable,
	Skipped: PlaidIdvStepStatus.Skipped,
	Expired: PlaidIdvStepStatus.Expired,
	Canceled: PlaidIdvStepStatus.Canceled,
	PendingReview: PlaidIdvStepStatus.PendingReview,
	ManuallyApproved: PlaidIdvStepStatus.ManuallyApproved,
	ManuallyRejected: PlaidIdvStepStatus.ManuallyRejected,
	toList: () => [
		{ value: PLAID_IDV_STEP_STATUS.Success, display: 'Success' },
		{ value: PLAID_IDV_STEP_STATUS.Active, display: 'Active' },
		{ value: PLAID_IDV_STEP_STATUS.Failed, display: 'Failed' },
		{
			value: PLAID_IDV_STEP_STATUS.WaitingForPrerequisite,
			display: 'Waiting for Prerequisite',
		},
		{ value: PLAID_IDV_STEP_STATUS.NotApplicable, display: 'Not Applicable' },
		{ value: PLAID_IDV_STEP_STATUS.Skipped, display: 'Skipped' },
		{ value: PLAID_IDV_STEP_STATUS.Expired, display: 'Expired' },
		{ value: PLAID_IDV_STEP_STATUS.Canceled, display: 'Canceled' },
		{ value: PLAID_IDV_STEP_STATUS.PendingReview, display: 'Pending Review' },
		{
			value: PLAID_IDV_STEP_STATUS.ManuallyApproved,
			display: 'Manually Approved',
		},
		{
			value: PLAID_IDV_STEP_STATUS.ManuallyRejected,
			display: 'Manually Rejected',
		},
	],
	getDisplay: value => PLAID_IDV_STEP_STATUS.toList().find(v => v.value === value)?.display,
};

export const IDV_STORE_SETTINGS = {
	Optional: IDVStoreSettings.Optional,
	Required: IDVStoreSettings.Required,

	toList: () => [
		{ value: IDV_STORE_SETTINGS.Optional, display: 'Optional' },
		{ value: IDV_STORE_SETTINGS.Required, display: 'Required' },
	],
};

export const DocumentGenerationType = {
	Paperwork: DocumentGenerationTypeEnum.Paperwork,
	Uploaded: DocumentGenerationTypeEnum.Uploaded,

	toList: () => [
		{ value: DocumentGenerationType.Paperwork, display: 'Paperwork' },
		{ value: DocumentGenerationType.Uploaded, display: 'Uploaded' },
	],
	getDisplay: value => DocumentGenerationType.toList().find(v => v.value === value)?.display,
};

export const PLAID_INTERACTION = {
	Unknown: PlaidInteraction.Unknown,
	GetIdentityVerification: PlaidInteraction.GetIdentityVerification,
	GetIdentity: PlaidInteraction.GetIdentity,
	GetAccountsBalance: PlaidInteraction.GetAccountsBalance,
	GetCreditSessions: PlaidInteraction.GetCreditSessions,
	GetBankIncome: PlaidInteraction.GetBankIncome,
	GetPayrollIncome: PlaidInteraction.GetPayrollIncome,
	RefreshBankIncome: PlaidInteraction.RefreshBankIncome,
	GetAuth: PlaidInteraction.GetAuth,
	CreateAssetReport: PlaidInteraction.CreateAssetReport,
	GetAssetReport: PlaidInteraction.GetAssetReport,
	RefreshAssetReport: PlaidInteraction.RefreshAssetReport,
	RemoveAssetReport: PlaidInteraction.RemoveAssetReport,
	GetTransfer: PlaidInteraction.GetTransfer,
	TransferEvent: PlaidInteraction.TransferEvent,
	CreateTransferAuth: PlaidInteraction.CreateTransferAuth,
	CreateTransfer: PlaidInteraction.CreateTransfer,
	LinkSession: PlaidInteraction.LinkSession,
	WebhookItemError: PlaidInteraction.WebhookItemError,
	WebhookIDVStatusUpdated: PlaidInteraction.WebhookIDVStatusUpdated,
	GetStatementsList: PlaidInteraction.GetStatementsList,
	GetIndividualWatchlistScreening: PlaidInteraction.GetIndividualWatchlistScreening,
};

export const TOKEN_STATUS = {
	Revoked: TokenStatus.Revoked,
	Active: TokenStatus.Active,
	Expired: TokenStatus.Expired,
	NearlyExpired: TokenStatus.NearlyExpired,
};

export const DOC_ASSOCIATION = {
	Admin: DocAssociation.Admin,
	Other: DocAssociation.Other,
	CustomerApplication: DocAssociation.CustomerApplication,
	Deal: DocAssociation.Deal,
	Customer: DocAssociation.Customer,
	UploadedDocument: DocAssociation.UploadedDocument,
	PaperworkDocument: DocAssociation.PaperworkDocument,
	Store: DocAssociation.Store,
	PlaidAccessToken: DocAssociation.PlaidAccessToken,
	PlaidTransfer: DocAssociation.PlaidTransfer,
	PlaidExchange: DocAssociation.PlaidExchange,
	PlaidIDVSession: DocAssociation.PlaidIDVSession,
	DDIDealId: DocAssociation.DDIDealId,
	DDIDocumentId: DocAssociation.DDIDocumentId,
	DDIVehicleInquiry: DocAssociation.DDIVehicleInquiry,
	PlateTransaction: DocAssociation.PlateTransaction,
	CreditReport: DocAssociation.CreditReport,
	AutoCompleteExchange: DocAssociation.AutoCompleteExchange,
	R1DocumentId: DocAssociation.R1DocumentId,
	VIN: DocAssociation.VIN,
	Plate: DocAssociation.Plate,
	Employee: DocAssociation.Employee,
	FraudCheck: DocAssociation.FraudCheck,
	RedirectInfo: DocAssociation.RedirectInfo,
	Business: DocAssociation.Business,
	CustomerVehicle: DocAssociation.CustomerVehicle,
};

export const R1CreditDecision = {
	APPROVED: R1CreditDecisionEnum.Approved,
	DENIED: R1CreditDecisionEnum.Denied,
	CONDITION: R1CreditDecisionEnum.Condition,
	PRELIMINARY: R1CreditDecisionEnum.Preliminary,
	WITHDRAWN: R1CreditDecisionEnum.Withdrawn,
	CONTRACT_RECEIVED: R1CreditDecisionEnum.ContractReceived,
	BOOKED: R1CreditDecisionEnum.Booked,
	NEW: R1CreditDecisionEnum.New,
	CONTRACT_HELD: R1CreditDecisionEnum.ContractHeld,
	CONTRACT_REJECTED: R1CreditDecisionEnum.ContractRejected,
	FUNDED: R1CreditDecisionEnum.Funded,
	ADDITIONAL_DOCUMENTS_RECEIVED: R1CreditDecisionEnum.AdditionalDocumentsReceived,
};

export const DealChecklistType = {
	Other: DealChecklistTypeEnum.Other,
	Upload_Image: DealChecklistTypeEnum.Upload_Image,
	Upload_File: DealChecklistTypeEnum.Upload_File,
	VisitLink: DealChecklistTypeEnum.VisitLink,
	LaunchPlaid_IDV: DealChecklistTypeEnum.LaunchPlaid_IDV,
	LaunchPlaid_BankIncome: DealChecklistTypeEnum.LaunchPlaid_BankIncome,
	LaunchPlaid_PayrollIncome: DealChecklistTypeEnum.LaunchPlaid_PayrollIncome,
	LaunchPlaid_AssetReport: DealChecklistTypeEnum.LaunchPlaid_AssetReport,
	LaunchPlaid_Statements: DealChecklistTypeEnum.LaunchPlaid_Statements,
	//Transfer_PlaidBankTransfer: 20,
};

export const DDISubmitDocumentTypes = {
	AFTB: DDISubmitDocumentTypesEnum.AFTB,
	AFTF: DDISubmitDocumentTypesEnum.AFTF,
	BOS: DDISubmitDocumentTypesEnum.BOS,
	CID: DDISubmitDocumentTypesEnum.CID,
	CWS: DDISubmitDocumentTypesEnum.CWS,
	DCR: DDISubmitDocumentTypesEnum.DCR,
	DRAF: DDISubmitDocumentTypesEnum.DRAF,
	FLR: DDISubmitDocumentTypesEnum.FLR,
	FLTB: DDISubmitDocumentTypesEnum.FLTB,
	FLTF: DDISubmitDocumentTypesEnum.FLTF,
	FLTR: DDISubmitDocumentTypesEnum.FLTR,
	GAF: DDISubmitDocumentTypesEnum.GAF,
	IAF: DDISubmitDocumentTypesEnum.IAF,
	IEF: DDISubmitDocumentTypesEnum.IEF,
	LAG: DDISubmitDocumentTypesEnum.LAG,
	LAOS: DDISubmitDocumentTypesEnum.LAOS,
	LOG: DDISubmitDocumentTypesEnum.LOG,
	LSF: DDISubmitDocumentTypesEnum.LSF,
	MLO: DDISubmitDocumentTypesEnum.MLO,
	MSOB: DDISubmitDocumentTypesEnum.MSOB,
	MSOF: DDISubmitDocumentTypesEnum.MSOF,
	NDA: DDISubmitDocumentTypesEnum.NDA,
	NOLB: DDISubmitDocumentTypesEnum.NOLB,
	NOLF: DDISubmitDocumentTypesEnum.NOLF,
	NOS: DDISubmitDocumentTypesEnum.NOS,
	OOSP: DDISubmitDocumentTypesEnum.OOSP,
	OOSR: DDISubmitDocumentTypesEnum.OOSR,
	OSTB: DDISubmitDocumentTypesEnum.OSTB,
	OSTF: DDISubmitDocumentTypesEnum.OSTF,
	POA: DDISubmitDocumentTypesEnum.POA,
	POB: DDISubmitDocumentTypesEnum.POB,
	PSTC: DDISubmitDocumentTypesEnum.PSTC,
	PSTE: DDISubmitDocumentTypesEnum.PSTE,
	RDOC: DDISubmitDocumentTypesEnum.RDOC,
	SODS: DDISubmitDocumentTypesEnum.SODS,
	SPOA: DDISubmitDocumentTypesEnum.SPOA,
	TAG: DDISubmitDocumentTypesEnum.TAG,
	VAOV: DDISubmitDocumentTypesEnum.VAOV,
	WIL: DDISubmitDocumentTypesEnum.WIL,
};

export const PLATE_TRANSACTIONS_TYPES = {
	None: PlateTransactionType.None,
	Transfer: PlateTransactionType.Transfer,
	NewTempPlate: PlateTransactionType.NewTempPlate,
	NewMetal: PlateTransactionType.NewMetal,
	Replacement: PlateTransactionType.Replacement,
	Salvage: PlateTransactionType.Salvage,
	toList: () => [
		{ display: 'None', value: PLATE_TRANSACTIONS_TYPES.None },
		{ display: 'PlateTransfer', value: PLATE_TRANSACTIONS_TYPES.Transfer },
		{ display: 'NewTempPlate', value: PLATE_TRANSACTIONS_TYPES.NewTempPlate },
		{ display: 'NewMetal', value: PLATE_TRANSACTIONS_TYPES.NewMetal },
		{ display: 'Replacement', value: PLATE_TRANSACTIONS_TYPES.Replacement },
		{ display: 'Salvage', value: PLATE_TRANSACTIONS_TYPES.Salvage },
	],
	getDisplay: VALUE => PLATE_TRANSACTIONS_TYPES.toList().find(f => f.value === VALUE)?.display,
};

export const DataModel = {
	Paperwork: DataModelEnum.Paperwork,
	Settings: DataModelEnum.Settings,
	Checklist: DataModelEnum.Checklist,
	Accounting: DataModelEnum.Accounting,
	Lender: DataModelEnum.Lender,
	Cancellation: DataModelEnum.Cancellation,
	BuyersOrder: DataModelEnum.BuyersOrder,
	ELead: DataModelEnum.ELead,
	FinanceChannels: DataModelEnum.FinanceChannels,
	PartnerCodes: DataModelEnum.PartnerCodes,
	Global: DataModelEnum.Global,
	toList: api => [
		{
			value: DataModel.Paperwork,
			display: 'Paperwork',
			getEmptyModel: api.fimenu.getEmptyPaperworkDocumentModel,
			getModel: api.fimenu.getDealPaperworkDocumentModel,
		},
		{
			value: DataModel.Settings,
			display: 'Settings',
			getEmptyModel: api.fimenu.getEmptySettingsDocumentModel,
			getModel: api.fimenu.getSettingsDocumentModel,
		},
		{
			value: DataModel.Checklist,
			display: 'Checklist',
			getEmptyModel: () => {},
			getModel: api.fimenu.getChecklistDocumentModel,
		},
		{
			value: DataModel.Accounting,
			display: 'Accounting',
			getEmptyModel: () => {},
			getModel: api.accounting.getAccountingExpressionModel,
		},
		{
			value: DataModel.Lender,
			display: 'Lender',
			getEmptyModel: api.fimenu.getEmptyLenderExpressionModel,
			getModel: api.fimenu.getLenderExpressionModel,
		},
		{
			value: DataModel.Cancellation,
			display: 'Cancellation',
			getEmptyModel: api.fimenu.getEmptyCancelDocumentModel,
			getModel: api.fimenu.getCancelDocumentModel,
		},
		{
			value: DataModel.BuyersOrder,
			display: 'Buyers Order',
			getEmptyModel: () => {},
			getModel: api.fimenu.getBuyersOrderModel,
		},
		{
			value: DataModel.ELead,
			display: 'ELead',
			getEmptyModel: () => {},
			getModel: api.fimenu.getELeadExpressionModel,
		},
		{
			value: DataModel.FinanceChannels,
			display: 'Finance Channels',
			getEmptyModel: () => {},
			getModel: api.fimenu.getFinanceChannelsModel,
		},
		{
			value: DataModel.PartnerCodes,
			display: 'Partner Codes',
			getEmptyModel: () => {},
			getModel: api.fimenu.getPartnerCodeModel,
		},
	],
};

export const DATA_FORMAT = {
	JSON: DataFormat.JSON,
	XML: DataFormat.XML,
};

export const connectionStatuses = ['4g', '3g', '2g', 'slow-2g', 'disconnected'];

export const MAPPING_TYPES = [
	{
		id: 'CarCalcToRouteOneTax',
		display: 'CarCalcs to RouteOne - Taxes',
		fromList: 'getCarCalcsTitleIdsDropDown',
		fromName: "CarCalcs Title ID's",
		toList: 'getRouteOneTaxesList',
		toName: 'RouteOne Tax List',
	},
	{
		id: 'CarCalcToRouteOneFee',
		display: 'CarCalcs to RouteOne - Fees',
		fromList: 'getCarCalcsTitleIdsDropDown',
		fromName: "CarCalcs Title ID's",
		toList: 'getRouteOneFeesList',
		toName: 'RouteOne Fee List',
	},
	{
		id: 'RouteOneToCarCalcTax',
		display: 'RouteOne to CarCalcs - Taxes',
		fromList: 'getRouteOneTaxesList',
		fromName: 'RouteOne  Fee List',
		toList: 'getCarCalcsTitleIdsDropDown',
		toName: "CarCalcs Title ID's",
	},
];

export const CUSTOMER_RETRIEVAL_STATUS = {
	NoApplication: CustomerRetrievalStatus.NoApplication,
	RetrieveApplicationEnabled: CustomerRetrievalStatus.RetrieveApplicationEnabled,
	RetrieveApplicationDisabled: CustomerRetrievalStatus.RetrieveApplicationDisabled,
	toList: () => [
		{
			display: 'No Application',
			value: CUSTOMER_RETRIEVAL_STATUS.NoApplication,
		},
		{
			display: 'Retrieve Application Enabled',
			value: CUSTOMER_RETRIEVAL_STATUS.RetrieveApplicationEnabled,
		},
		//{ display: 'Retrieve Application Disabled', value: 2 }
	],
	getDisplay: VALUE => CUSTOMER_RETRIEVAL_STATUS.toList().find(f => f.value === VALUE)?.display,
};

export const LenderContactType = {
	CustomerService: LenderContactTypeEnum.CustomerService,
	Payoff: LenderContactTypeEnum.Payoff,
	Origination: LenderContactTypeEnum.Origination,
	Funding: LenderContactTypeEnum.Funding,
};

export const LENDER_CONTACT_TYPES = [
	{ display: 'CUSTOMER SERVICE', value: LenderContactType.CustomerService },
	{ display: 'PAYOFF', value: LenderContactType.Payoff },
	{ display: 'ORIGINATION', value: LenderContactType.Origination },
	{ display: 'FUNDING', value: LenderContactType.Funding },
];

export const LenderDivisionType = {
	Mailing: LenderDivisionTypeEnum.Mailing,
	Lienholder: LenderDivisionTypeEnum.Lienholder,
	LossPayee: LenderDivisionTypeEnum.LossPayee,
	FIProductsLienholder: LenderDivisionTypeEnum.FIProductsLienholder,
	Lessor: LenderDivisionTypeEnum.Lessor,
	Payoff: LenderDivisionTypeEnum.Payoff,
	Fedex: LenderDivisionTypeEnum.Fedex,
	UPS: LenderDivisionTypeEnum.UPS,
};

export const LENDER_DIVISION_TYPES = [
	{ display: 'MAILING', value: LenderDivisionType.Mailing },
	{ display: 'LIENHOLDER', value: LenderDivisionType.Lienholder },
	{ display: 'LOSS PAYEE', value: LenderDivisionType.LossPayee },
	{
		display: 'FI PRODUCTS LIENHOLDER',
		value: LenderDivisionType.FIProductsLienholder,
	},
	{ display: 'LESSOR', value: LenderDivisionType.Lessor },
	{ display: 'PAY OFF', value: LenderDivisionType.Payoff },
	{ display: 'FEDEX', value: LenderDivisionType.Fedex },
	{ display: 'UPS', value: LenderDivisionType.UPS },
];

export const REDIRECT_TYPE = {
	Other: RedirectType.Other,
	CustomerChecklist: RedirectType.CustomerChecklist,
	PlaidLinkPortal: RedirectType.PlaidLinkPortal,
	RecoverPassword: RedirectType.RecoverPassword,
};

export const MEETING_PARTICIPANT = {
	FI_MANAGER: MeetingParticipant.FIManager,
	CUSTOMER: MeetingParticipant.Customer,
	CO_CUSTOMER: MeetingParticipant.COCustomer,
	GUEST: MeetingParticipant.Guest,
};

export const BROADCAST_MESSAGE_TYPE = {
	PING: BroadcastMessageType.Ping,
	ESIGN_START: BroadcastMessageType.ESignStart,
	ESIGN_COMPLETE: BroadcastMessageType.ESignComplete,
};

export const LegalTermTypes = {
	TERMS_AND_CONDITIONS: LegalTermTypesEnum.TermsAndConditions,
	ADVERSE_ACTION_NOTICE: LegalTermTypesEnum.AdverseActionNotice,
	PRIVACY_NOTICE: LegalTermTypesEnum.PrivacyNotice,
	SMS_CONSENT: LegalTermTypesEnum.SMSConsent,
};

export const LEGAL_TERM_TYPES = [
	{
		display: 'Terms and Conditions',
		value: LegalTermTypes.TERMS_AND_CONDITIONS,
	},
	{
		display: 'Adverse Action Notice',
		value: LegalTermTypes.ADVERSE_ACTION_NOTICE,
	},
	{ display: 'Privacy Notice', value: LegalTermTypes.PRIVACY_NOTICE },
	{ display: 'SMS Consent', value: LegalTermTypes.SMS_CONSENT },
];

export const DEAL_STATUS = {
	DEAD: DealStatuses.Dead,
	SALES_IN_PROCESS: DealStatuses.SalesInProcess,
	SALES_FINISHED: DealStatuses.SalesFinished,
	SALES_MANAGER_IN_PROCESS: DealStatuses.SalesManagerInProcess,
	SALES_MANAGER_FINISHED: DealStatuses.SalesManagerFinished,
	FI_IN_PROCESS: DealStatuses.FiInProcess, // F & I  processing
	FI_FINISHED: DealStatuses.FiFinished, // F & I can unlock
	FI_ADMIN_IN_PROCESS: DealStatuses.FiAdminInProcess,
	FI_ADMIN_FINISHED: DealStatuses.FiAdminFinished, // Accounting Posts deal
	ACCOUNTING_IN_PROCESS: DealStatuses.AccountingInProcess, // Accounting enters deal or deal gets unwinded
	ACCOUNTING_FINISHED: DealStatuses.AccountingFinished, // Accounting Posts deal
	FINALIZED: DealStatuses.Finalized, // Accounting Posts deal
	toList: () => [
		{
			display: 'Dead',
			departmentRole: DepartmentRoles.None,
			department: null,
			value: DEAL_STATUS.DEAD,
		},
		{
			display: 'Sales Person In Process',
			departmentRole: DepartmentRoles.Sales,
			department: Department.Sales,
			value: DEAL_STATUS.SALES_IN_PROCESS,
		},
		{
			display: 'Sales Person Finished',
			departmentRole: DepartmentRoles.Sales,
			department: Department.Sales,
			value: DEAL_STATUS.SALES_FINISHED,
		},
		{
			display: 'Sales Manager In Process',
			departmentRole: DepartmentRoles.Sales,
			department: Department.Sales,
			value: DEAL_STATUS.SALES_MANAGER_IN_PROCESS,
		},
		{
			display: 'Sales Manager Finished',
			departmentRole: DepartmentRoles.Sales,
			department: Department.Sales,
			value: DEAL_STATUS.SALES_MANAGER_FINISHED,
		},
		{
			display: 'F&I In Process',
			departmentRole: DepartmentRoles.FI,
			department: Department.Finance,
			value: DEAL_STATUS.FI_IN_PROCESS,
		},
		{
			display: 'F&I Finished',
			departmentRole: DepartmentRoles.FI,
			department: Department.Finance,
			value: DEAL_STATUS.FI_FINISHED,
		},
		{
			display: 'F&I Admin In Processed',
			departmentRole: DepartmentRoles.FI,
			department: Department.Finance,
			value: DEAL_STATUS.FI_ADMIN_IN_PROCESS,
		},
		{
			display: 'F&I Admin Finalized',
			departmentRole: DepartmentRoles.FI,
			department: Department.Finance,
			value: DEAL_STATUS.FI_ADMIN_FINISHED,
		},
		{
			display: 'Accounting In Process',
			departmentRole: DepartmentRoles.Accounting,
			department: Department.Accounting,
			value: DEAL_STATUS.ACCOUNTING_IN_PROCESS,
		},
		{
			display: 'Accounting Finished',
			departmentRole: DepartmentRoles.Accounting,
			department: Department.Accounting,
			value: DEAL_STATUS.ACCOUNTING_FINISHED,
		},
		{
			display: 'Finalized',
			departmentRole: DepartmentRoles.None,
			department: null,
			value: DEAL_STATUS.FINALIZED,
		},
	],
	getDisplay: value => DEAL_STATUS.toList().find(v => v.value === value)?.display,
	getDepartmentRole: value => DEAL_STATUS.toList().find(v => v.value === value)?.departmentRole,
};

export const USER_ACCESSES = {
	SALES_MANAGER: UserAccesses.SalesManager,
	SALES_PERSON: UserAccesses.SalesPerson,
	FI_MANAGER: UserAccesses.FiManager,
	GENERAL_MANAGER: UserAccesses.GeneralManager,
	SERVICE_MANAGER: UserAccesses.ServiceManager,
	DIRECTOR: UserAccesses.Director,
	ACCOUNTING: UserAccesses.Accounting,
	USER_MANAGER: UserAccesses.UserManager,
	ADMIN: UserAccesses.Admin,
};

export const PANEL_CUSTOMER_STEPS = {
	CUSTOMER_INFORMATION: PanelCustomerSteps.CustomerInformation,
	IDENTITY_VERIFICATION: PanelCustomerSteps.IdentityVerification,
	REDFLAGS: PanelCustomerSteps.RedFlags,
	CREDITREPORT: PanelCustomerSteps.CreditReport,
	CREDITAPPLICATION: PanelCustomerSteps.CreditApplication,
	QUOTES: PanelCustomerSteps.Quotes,
	DEALS: PanelCustomerSteps.Deals,
};

export const REPORT_TYPES = {
	PRODUCTS_ACTIVATION_VOIDED: ReportTypes.ProductsActivationVoided,
	CBC_CREDIT_PULLS: ReportTypes.CbcCreditPulls,
	DEALS_REPORT: ReportTypes.DealsReport,
	PLAID_REPORT: ReportTypes.PlaidReport,
	TRADEINS_ACCIDENT_REPORT: ReportTypes.TradeInsAccidentReport,
	toList: () => [
		{ value: REPORT_TYPES.PRODUCTS_ACTIVATION_VOIDED, display: 'F&I Products' },
		{ value: REPORT_TYPES.CBC_CREDIT_PULLS, display: 'Credit Report' },
		{ value: REPORT_TYPES.DEALS_REPORT, display: 'Deals Report' },
		{
			value: REPORT_TYPES.TRADEINS_ACCIDENT_REPORT,
			display: 'Trade-Ins Accident Report',
		},
		//{ value: REPORT_TYPES.PLAID, display: "Plaid Report" }
	],
	getDisplay: value => REPORT_TYPES.toList().find(v => v.value === value)?.display,
};

export const STATUS_TYPES = {
	UNDEFINED: StatusTypes.Undefined,
	FLOW: StatusTypes.Flow,
	CIT: StatusTypes.CIT,
	TITLE: StatusTypes.Title,
	VEHICLE: StatusTypes.Vehicle,
	FLOOR_PLAN: StatusTypes.FloorPlan,
	toList: () => [
		{
			value: STATUS_TYPES.UNDEFINED,
			display: '',
			fimenuProperty: null,
			statusIcon: null,
		},
		{
			value: STATUS_TYPES.FLOW,
			display: 'Flow',
			fimenuProperty: 'flowStatus',
			statusIcon: 'fas fa-list-ul',
			abbreviation: 'FL',
		},
		{
			value: STATUS_TYPES.CIT,
			display: 'CIT',
			fimenuProperty: 'citStatus',
			statusIcon: 'far fa-file-alt',
			abbreviation: 'CIT',
		},
		{
			value: STATUS_TYPES.TITLE,
			display: 'Title',
			fimenuProperty: 'titleStatus',
			statusIcon: 'far fa-address-card',
			abbreviation: 'TL',
		},
		{
			value: STATUS_TYPES.VEHICLE,
			display: 'Vehicle',
			fimenuProperty: 'vehicleStatus',
			statusIcon: 'fas fa-car-side',
			abbreviation: 'VH',
		},
		{
			value: STATUS_TYPES.FLOOR_PLAN,
			display: 'Floor Plan',
			fimenuProperty: 'floorPlanStatus',
			statusIcon: null,
			abbreviation: 'FP',
		},
	],
	getDisplay: value => STATUS_TYPES.toList().find(v => v.value === value)?.display,
	getFimenuProperty: value => STATUS_TYPES.toList().find(v => v.value === value)?.fimenuProperty,
	getValue: display => STATUS_TYPES.toList().find(v => v.display === display)?.value,
	getStatusIcon: value => STATUS_TYPES.toList().find(v => v.value === value)?.statusIcon,
	getAbbreviation: value => STATUS_TYPES.toList().find(v => v.value === value)?.abbreviation,
};

export const STATUS_PRIORITY_ORDER = {
	HIGH_3: StatusPriorityOrder.High3,
	HIGH_2: StatusPriorityOrder.High2,
	HIGH_1: StatusPriorityOrder.High1,
	MEDIUM_3: StatusPriorityOrder.Medium3,
	MEDIUM_2: StatusPriorityOrder.Medium2,
	MEDIUM_1: StatusPriorityOrder.Medium1,
	LOW_3: StatusPriorityOrder.Low3,
	LOW_2: StatusPriorityOrder.Low2,
	LOW_1: StatusPriorityOrder.Low1,
	toList: () => [
		{ value: STATUS_PRIORITY_ORDER.HIGH_3, display: 'High (3)', color: '' },
		{ value: STATUS_PRIORITY_ORDER.HIGH_2, display: 'High (2)', color: '' },
		{ value: STATUS_PRIORITY_ORDER.HIGH_1, display: 'High (1)', color: '' },
		{ value: STATUS_PRIORITY_ORDER.MEDIUM_3, display: 'Medium (3)', color: '' },
		{ value: STATUS_PRIORITY_ORDER.MEDIUM_2, display: 'Medium (2)', color: '' },
		{ value: STATUS_PRIORITY_ORDER.MEDIUM_1, display: 'Medium (1)', color: '' },
		{ value: STATUS_PRIORITY_ORDER.LOW_3, display: 'Low (3)', color: '' },
		{ value: STATUS_PRIORITY_ORDER.LOW_2, display: 'Low (2)', color: '' },
		{ value: STATUS_PRIORITY_ORDER.LOW_1, display: 'Low (1)', color: '' },
	],
	getDisplay: value => STATUS_PRIORITY_ORDER.toList().find(v => v.value === value)?.display,
};

export const STATUS_WEIGHT = {
	NONE: StatusWeight.None,
	MINUS_ONE: StatusWeight.MinusOne,
	PLUS_ONE: StatusWeight.PlusOne,
	toList: () => [
		{ value: STATUS_WEIGHT.MINUS_ONE, display: '-1' },
		{ value: STATUS_WEIGHT.PLUS_ONE, display: '1' },
		{ value: STATUS_WEIGHT.NONE, display: '0' },
	],
	getDisplay: value => STATUS_WEIGHT.toList().find(v => v.value === value)?.display,
};

export const REPORT_FIELD_TYPES = {
	DATE: ReportFieldTypes.Date,
	PROVIDERS: ReportFieldTypes.Providers,
	PRODUCTS: ReportFieldTypes.Products,
	STORES: ReportFieldTypes.Stores,
	CHECKBOX: ReportFieldTypes.Checkbox,
	DEALSTATUSES: ReportFieldTypes.DealStatuses,
};

export const RICHTABLE_RANGE_FILTER_TYPES = {
	NUMERIC: RichTableRangeFilterTypes.Numeric,
	DATE: RichTableRangeFilterTypes.Date,
	TERM: RichTableRangeFilterTypes.Term,
};

export const HTTP_STATUS_CODE = {
	PROCESSING: HttpStatusCode.Processing,
	OK: HttpStatusCode.Ok,
	ACCEPTED: HttpStatusCode.Accepted,
	NO_CONTENT: HttpStatusCode.NoContent,
	REFRESH_CONTENT: HttpStatusCode.RefreshContent,
};

export const VIDEO_SOURCE_TYPE = {
	NONE: VideoSourceType.None,
	STAFF_SCREEN: VideoSourceType.StaffScreen,
	CUSTOMER_SCREEN: VideoSourceType.CustomerScreen,
	STAFF_CAMERA: VideoSourceType.StaffCamera,
	CUSTOMER_CAMERA: VideoSourceType.CustomerCamera,
	COCUSTOMER_SCREEN: VideoSourceType.CocustomerScreen,
	COCUSTOMER_CAMERA: VideoSourceType.CocustomerCamera,
	toList: () => [
		{ value: VIDEO_SOURCE_TYPE.NONE, display: 'None' },
		{ value: VIDEO_SOURCE_TYPE.STAFF_SCREEN, display: 'Staff Screen' },
		{ value: VIDEO_SOURCE_TYPE.CUSTOMER_SCREEN, display: 'Customer Screen' },
		{ value: VIDEO_SOURCE_TYPE.STAFF_CAMERA, display: 'Staff Camera' },
		{ value: VIDEO_SOURCE_TYPE.CUSTOMER_CAMERA, display: 'Customer Camera' },
		{
			value: VIDEO_SOURCE_TYPE.COCUSTOMER_SCREEN,
			display: 'Cocustomer Screen',
		},
		{
			value: VIDEO_SOURCE_TYPE.COCUSTOMER_CAMERA,
			display: 'Cocustomer Camera',
		},
	],
	getDisplay: value => VIDEO_SOURCE_TYPE.toList().find(v => v.value === value)?.display,
};

export const DATA_DEFINITIONS_TYPE = [
	{
		value: DataDefinitionType.FinanceChannelsRouteOneDJ,
		display: 'R1 DealJacket',
	},
	{
		value: DataDefinitionType.RouteOneEContract,
		display: 'R1 E-Contract',
	},
];

export const EXCEPTION_TYPE = {
	UNKNOWN: ExceptionType.Unknown,
	FRAUD: ExceptionType.Fraud,
};

export const FRAUD_RISK_LEVEL = {
	UNKNOWN: FraudRiskLevel.Unknown,
	NO_RISK: FraudRiskLevel.NoRisk,
	LOW_RISK: FraudRiskLevel.LowRisk,
	HIGH_RISK: FraudRiskLevel.HighRisk,
};

export const COMPONENT_API = {
	Options: ComponentApi.Options,
	Composition: ComponentApi.Composition,
};

export const EVENT_EMITS = {
	BROADCAST: {
		SEND_GLOBAL_MESSAGE: 'broadcastSendGlobalMessage',
		POST_DEPLOY_LOGS_MESSAGE: 'broadcastPostDeployLogsMessage',
		HELP_NOTIFICATION: 'broadcastHelpNotification',
		CUSTOMER_JOINED_MEETING: 'broadcastCustomerJoinedMeeting',
		CUSTOMER_WAITING_MEETING: 'broadcastCustomerWaitingMeeting',
		CUSTOMER_LEFT_MEETING: 'broadcastCustomerLeftMeeting',
	},
};

const ENUMS = {
	EVENT_EMITS,
	USER_ACCESSES,
	PaperworkDocumentStatus,
	PAPERWORK_DOCUMENT_TYPES,
	paperworkDocumentTypes,
	docTypesThatWeActivate,
	REASON_OF_CANCELLATION,
	ReasonOfCancellation,
	LANG,
	SOUNDS,
	PARTNER_CODES,
	CBC_REPORT_TYPES,
	SSN_TYPES,
	CUSTOMER_APPLICATION_STATUS,
	PARTNER_CODES_TYPES,
	states,
	LOG_WHAT,
	LOG_HOW,
	LOG_WHERE,
	PRODUCT_TYPES,
	productTypes,
	FUEL_TYPES,
	fuelTypes,
	bodyTypes,
	addressType,
	addressTypeEnum,
	API_ERROR_DESCRIPTION,
	VIDEOS_SEEN,
	CDK_MAPPING_LOCATION,
	OIL_TYPES,
	oilTypes,
	STORE_FILE_TYPES,
	PARTNER_PAPERWORK_METHODS,
	partnerPaperworkMethods,
	CUSTOMER_TRIGGERS,
	FIMANAGER_TRIGGERS,
	OVERLAY_TYPES,
	PERSON_TYPES,
	CUSTOMER_VIEWS,
	customerViews,
	VIDEOS_SEEN_TITLES,
	VEHICLE_MILEAGE_STATUS,
	VEHICLE_PRIMARY_USAGE,
	VEHICLE_SURCHARGES,
	otherVehicleInfo,
	WARRANTY_EXPIRATION_DATE_RULES,
	WARRANTY_EXPIRATION_MILES_RULES,
	PAPERWORK_STATUS,
	PaperworkStatusText,
	PaperworkSignedStatusText,
	CREDIT_APP_RESIDENCE_STATUS,
	CREDIT_APP_RESIDENCE_STATUS_TITLE,
	CREDIT_APP_EMPLOYMENT_STATUS,
	CREDIT_APP_EMPLOYMENT_STATUS_TITLE,
	CREDIT_APP_TYPE_EMPLOYEE,
	CREDIT_APP_TYPE_EMPLOYEE_TITLE,
	DEAL_TYPES,
	CDK_DEAL_STATUS,
	CREDIT_APP_BUTTONS_ACTIONS,
	CUSTOMER_IDENTIFICATION_TYPES,
	dealEmployeeRoleTypes,
	DEAL_EMPLOYEE_ROLE_TYPES,
	PRICING_PLAN_SELECTORS,
	pricingPlanSelectors,
	PRICING_LIST_OPTION_PRICE_SPLITS,
	pricingListOptionPriceSplits,
	PROFIT_FLAGS,
	PROFIT_METHODS,
	PayoffQuoteInquiryTypeProductType,
	PayoffQuoteInquiryTypeInquiryType,
	ADDITION_TYPES,
	RATING_STATUS,
	TEXT_MESSAGING_PROVIDERS,
	textMessagingProviders,
	CANCEL_COVERAGE_STATUS,
	CANCEL_COVERAGE_APPLY_FUNDS_TO,
	AUDIT_TRAIL_OPERATIONS,
	CUSTOMER_DOCUMENT_TYPE,
	CUSTOMER_DOCUMENT_SUBTYPE,
	DEAL_ROOM_STATE,
	DEAL_GOAL_TYPES,
	DEAL_LOJACK_STATUS,
	COMPARISON_TYPE,
	RT_FILE_TYPES,
	PLAID_PRODUCTS,
	PLAID_LANGUAGES,
	PLAID_COUNTRIES,
	PLAID_ID_TYPES,
	PLAID_INCOME_TYPE,
	PLAID_PAYROLL_FLOW,
	PLAID_INCOME_SOURCE,
	PLAID_PAY_TYPE,
	PLAID_PAY_FREQUENCY,
	PLAID_VERIFICATION_STATUS,
	PLAID_IDV_STEP_STATUS,
	PLAID_INTERACTION,
	TOKEN_STATUS,
	VEHICLE_DELIVERY_METHODS,
	DOC_ASSOCIATION,
	R1CreditDecision,
	DealChecklistType,
	MAPPING_TYPES,
	LenderContactType,
	LENDER_CONTACT_TYPES,
	LenderDivisionType,
	LENDER_DIVISION_TYPES,
	DataModel,
	DATA_FORMAT,
	connectionStatuses,
	DDISubmitDocumentTypes,
	PLATE_TRANSACTIONS_TYPES,
	CUSTOMER_APPLICATION_EMPLOYMENT_STATUS,
	CUSTOMER_APPLICATION_EMPLOYMENT_TITLE,
	CUSTOMER_APPLICATION_HOUSING_STATUS,
	CUSTOMER_APPLICATION_HOUSING_TITLE,
	CUSTOMER_RETRIEVAL_STATUS,
	CUSTOMER_APPLICATION_ENTERPRISE_TYPE,
	LegalTermTypes,
	LEGAL_TERM_TYPES,
	LANGUAGE,
	LANGUAGE_DISPLAY,
	REDIRECT_TYPE,
	DEAL_STATUS,
	CREDITREPORT_FLAG_TYPES,
	CREDITREPORT_BUREAU_ERROR_CODE,
	CREDITREPORT_REPORT_MESSAGES_CODES,
	DocumentGenerationType,
	CUSTOMER_CREATION_SOURCE,
	SATURN_CREDIT_BUREAURS,
	CUSTOMER_REDFLAGSTATUS,
	CBC_CREDIT_PULL_VERSIONS_FICO,
	PANEL_CUSTOMER_STEPS,
	IDV_STORE_SETTINGS,
	RICHTABLE_RANGE_FILTER_TYPES,
	REPORT_TYPES,
	REPORT_FIELD_TYPES,
	HTTP_STATUS_CODE,
	DROPDOWN_SORT_MODE,
	EXCEPTION_TYPE,
	FRAUD_RISK_LEVEL,
	VIDEO_SOURCE_TYPE,
	DATA_DEFINITIONS_TYPE,
	STATUS_TYPES,
	STATUS_PRIORITY_ORDER,
	EXTERNAL_DMS_SOURCE,
};

export default ENUMS;
